<!--
	作者：Shujuan Sun
	时间：2017-04-24
	描述：车辆监控页面_地图组件
-->

<template>
	<div v-bind:style="mapStyle" v-loading="loadmap" element-loading-text="处理中">
		<baidu-map style="height: 100%;box-shadow: 3px 3px 2px #888888" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom="enableScroll" :map-click="enableMapClick" @ready="ready">
		</baidu-map>
		<!--路况、卫星、围栏、路线（画路线）、测量、标注、规划、提示、清空-->
		<menu-map 
			:currentMenu='currentMenu' 
			v-on:trafficMode="traffic" 
			v-on:satellite="isHybridMap=!isHybridMap" 
			v-on:srchVehicle="srchVehicle"
			v-on:fence='drawFences' 
			v-on:route="path" 
			v-on:measure="enableMeasureTool =! enableMeasureTool" 
			v-on:addMarkers="addMarks" 
			v-on:routePlan="pathPlan" 
			v-on:changeInfoBox="setInfoWindow" 
			v-on:clearCarMarkers="clearMap"
			v-on:saveStyle="saveStyle"
			></menu-map>
		<menu-vehicle v-if="showMenuVehicle" :clickedInfo="clickedInfo" :defendStatus="defendStatus" :carSearching="carSearching" :stopException="stopException" v-on:streetView="jieJing" v-on:stopDefend="stopDefend" v-on:defend="drawDefend" v-on:unusualMove="moveAlarm" v-on:removeException='removeAlaram' v-on:makePlan="routePlan" v-on:startTrack="startTracking" v-on:stopTrack="stopTracking"></menu-vehicle>
		<menu-status></menu-status>
		<menu-map-tool :currentMenu='currentMenu' :enableDrawingTool='enableDrawingTool' :drawType='drawType' v-on:clearFence="clearFences" v-on:govArea='govArea' v-on:adSearch="adsSearch" v-on:fenceList='getFenceList' :pathType='pathType' :pathMenu="pathMenu" v-on:deleteRoute="delRoute" v-on:drawMode="drawRouteMode" v-on:pathList="getPathList" :infoType='labelMode' :infoWindowMenu='infoWindowMenu' v-on:noWin='noInfo' v-on:simpleWin="simpleInfo" v-on:standardWin="standardInfo" :measureType='measureType' :enableMeasureTool='enableMeasureTool' v-on:meRoad="measureRoad" v-on:meBeeline="measureBeeline" v-on:meArea="measureArea" v-on:coordinate="getCoordinate" v-on:searchAddress="getAddress" v-on:clearMeasure="measureClear" v-on:searchAdds="searchAds"></menu-map-tool>
		<!--拉框查车结果列表-->
		<dl v-show="srchedVehList.length > 0" class="veh_list">
			<dt>
				<span>请选择车辆</span>
				<img @click="closeSrchVeh" src="../../../assets/project/images/map/map_icon_5b.png"/>
			</dt>
			<dd class="title">&nbsp;服务卡号&nbsp;/&nbsp;设备号&nbsp;/&nbsp;sim卡号&nbsp;</dd>
			<dd class="srched_vehs">
				<p v-for="(vehInfo,index) in srchedVehList" :key="index" @click="getVehInfos(vehInfo)">&nbsp;{{vehInfo.vehicleAccount==''?'暂无':vehInfo.vehicleAccount}}&nbsp;/&nbsp;{{vehInfo.deviceNum==''?'暂无':vehInfo.deviceNum}}&nbsp;/&nbsp;{{vehInfo.simNum==''?'暂无':vehInfo.simNum}}&nbsp;</p>
				<p class="load_veh" v-show="srchedVehList.length % 10 === 0 && srchedVehList.length >= 10" @click="srchMoreVeh">加载更多...</p>
				<p class="load_veh" v-show="srchedVehList.length % 10 !== 0 && srchedVehList.length > 10">没有更多了</p>
			</dd>  
		</dl>
		<!--街景窗口-->
		<div v-if="streetViewLayer" class="street_view">
			<street-map :viewPosi="vehiclePosi" v-on:closeView="closeStreetView"></street-map>
		</div>
		<!--倒计时刷新提示-->
		<div class="refresh_time" v-if="refreshFlag" v-show="refreshSec==0">正在刷新</div>
		<div class="refresh_time" v-if="refreshFlag" v-show="refreshSec!==0">{{refreshSec}}秒后刷新</div>
		<!--取消异动或驻防弹框-->
		<tab-modal v-on:cancel="closeModalD" ref="modalD" size="small" :title="modalTitle">
			<div v-if="hasWithdraw">
				<p>您确定要为{{clickedInfo.showFiled1}}（ {{clickedInfo.showFiled2}}）取消{{stopType}}吗？</p>
			</div>
			<div v-else>
				<p>取消{{stopType}}成功</p>
			</div>
			<div slot="footer">
				<button v-if="hasWithdraw" class="btn btn-primary" @click="delWithdrawBtn">取消</button>
				<button class="btn btn-primary" @click="delConfirmBtn">确定</button>
			</div>
		</tab-modal>
		<!--画行政区划-->
		<tab-modal v-on:cancel="closeModalArea" ref="modalArea" size="small" title="行政区检索">
			<div class="form-group" v-bind:class="{ 'form-group--error': $v.govAName.$error }">
				<input type="text" class="form-control" v-model.trim="govAName" @blur="$v.govAName.$touch()" placeholder="请输入省、直辖市或县名称" />
				<span class="help-block form-group__message" v-if="!$v.govAName.required">该区域不能为空</span>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="drawGovArea" :disabled="!isSearchable">查询</button>
			</div>
		</tab-modal>
		<!--TabModal->drawDefend原地驻防保存,moveAlarm停车异动保存，drawFences,Routes,Markers画围栏-->
		<tab-modal ref="drawModal" size="small" :title="modalTitle" v-on:cancel="closeModal">
			<div v-if="saveFences">
				<!--区域保存(围栏、路线和标注)-->
				<div>
					<div class="form-group" v-bind:class="{ 'form-group--error': $v.content.$error }">
						<label for="" class="control-label">{{labelName}}:</label>
						<input type="text" class="form-control" v-model.trim="content" @blur="$v.content.$touch()" />
						<span class="help-block form-group__message" v-if="!$v.content.required">该区域不能为空</span>
					</div>
					<div class="form-group">
						<label for="" class="control-label">备注:</label>
						<input type="text" class="form-control" v-model="memo" />
					</div>
					<div class="form-group">
						<input name="authority" type="radio" value="0" v-model="visible" />仅对本企业可见
						<input name="authority" type="radio" value="1" v-model="visible" />对本企业及下级企业可见
					</div>
				</div>
			</div>
			<div v-if="saveDefend">
				<!--驻防和异动区域保存-->
				<div class="form-group">
					<label class="control-label">{{dialog1}}</label>
				</div>
				<div class="form-group">
					<label class="control-label">{{dialog2}}</label>
				</div>
				<div class="form-group">
					<div class="col-sm-10" v-bind:class="{ 'form-group--error': $v.alarmPlan.$error }">
						<select class="form-control" v-model.trim="alarmPlan" @blur="$v.alarmPlan.$touch()">
							<option :value="plan.planId" v-for="(plan,index) in alarmPlanList" :key="index">{{plan.planName}}</option>
						</select>
						<span class="help-block form-group__message" v-if="!$v.alarmPlan.required">该区域不能为空</span>
					</div>
					<div class="col-sm-2">
						<button class="btn btn-primary" @click="getAlmPlan">刷新</button>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button v-if="saveDefend" class="btn btn-primary" @click="openAlarmTab">{{openTabName}}</button>
				<button class="btn btn-primary" @click="saveBtn" :disabled="!isDisable">保存</button>
			</div>
		</tab-modal>
		<!--TabModal弹框组件---路线规划功能-->
		<tab-modal ref="planModal" size="small" :title="modalTitle" v-on:cancel="closeModal">
			<div>
				<div class="track_bottom_btn05">
					<i><a class="ico_01"  v-if="oneEnd" @click="switchPoints">交换位置</a></i>
					<i><a class="ico_02"  @click="addEnd">添加</a></i></div>
				<div id="planPanel">
					<div class="form-group point" v-bind:class="{ 'form-group--error': $v.startP.$error }">
						<label class="control-label">起点:</label>
						<input type="text" v-model.trim="startP" @input="$v.startP.$touch()" id="suggestId1" size="20" class="form-control" @focus.once="searchStart('suggestId1','searchResultPanel1')" />
						<div id="searchResultPanel1" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
						<span class="help-block form-group__message" v-if="!$v.startP.required">该区域不能为空</span>
					</div>
					<div class="form-group wayP" v-for="(wayInput,index) in wayInputs" :key="index">
						<label class="control-label">途经点:</label>
						<input type="text" :id="'id' + index" size="20" class="form-control" @focus.once="searchInput($event,'id' + index,'resId' + index)" />
						<div :id="'resId' + index" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
					</div>
					<div class="form-group point" v-bind:class="{ 'form-group--error': $v.endPoint.$error }">
						<label for="" class="control-label">终点:</label>
						<input type="text" v-model.trim="endPoint" @input="$v.endPoint.$touch()" id="suggestId2" size="20" class="form-control" @focus.once="searchEnd('suggestId2','searchResultPanel2')" />
						<div id="searchResultPanel2" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
						<span class="help-block form-group__message" v-if="!$v.endPoint.required">该区域不能为空</span>
					</div>
				</div>
				<div class="form-group mb0px">
					<label for="" class="control-label">规划方式:</label>
				</div>
				<div class="form-group  mb0px">
					<input type="radio" value="shortest" v-model="planMethod" class="mr5px" />距离最短
					<input type="radio" value="fastest" v-model="planMethod" class="ml20px mr5px" />速度最快
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="startPlan" :disabled="!isClickable">开始规划</button>
			</div>
		</tab-modal>
		<!--TabModal弹框->追车功能-->
		<tab-modal ref="trackModal" size="large" :title="modalTitle" v-on:cancel="closeModal">
			<div class="form-horizontal">
				<p class="red">
					进入追车模式后，系统将高速收集车辆的位置信息，同时，该车辆预置的定位装置也将进入“高耗电”的快速响应模式，这将会快速消耗无线定位设备中的电池，缩短无线定位设备的使用寿命。
				</p>
				<br />
				<div class="form-group">
					<label class="col-sm-1 control-label">车辆ID</label>
					<div class="col-sm-3">
						<input class="form-control" readonly value="VE8"/>
					</div>
					<label class="col-sm-1 control-label">服务卡号</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" readonly value="106546865">
					</div>
					<label class="col-sm-1 control-label">车牌号</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" readonly value="鲁B9GN92" />
					</div>
				</div> 
				<div class="form-group">
					<label class="col-sm-12 control-label t_left">上传时间间隔设置：</label>
				</div>
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>设备ID</th>
								<th>设备编号</th>
								<th>设备类型</th>
								<th>设备型号</th>
								<th>SIM卡号</th>
								<th>服务到期日</th>
								<th>上传间隔</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(chaseInfo,index) in chaseList" :key="index">
								<td>VD{{clickedInfo.deviceId}}</td>
								<td>{{chaseInfo.deviceNum}}</td>
								<td>{{chaseInfo.wifiFlag==1?'有线':'无线'}}</td>
								<td>{{chaseInfo.categoryNo}}</td>
								<td>{{chaseInfo.simNum}}</td> 
								<td>{{chaseInfo.serviceEndTime}}</td> 
								<td @click="setCmd"><a>设置</a></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="form-group">
					<label class="col-sm-12 control-label t_left">无线定位设备剩余电量预警设置：</label> 
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">第一次预警：</label> 
					<div class="col-sm-4">
						<label class="control-label">剩余电量</label>
						<input type="text" v-model="firstPowerNum"/>
						<span>%</span>
					</div>
					<label class="col-sm-2 control-label">第二次预警：</label> 
					<div class="col-sm-4">
						<label class="control-label">剩余电量</label>
						<input type="text" v-model="secondPowerNum"/>
						<span>%</span>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="withdrawBtn">取消</button>
				<button class="btn btn-primary" @click="confirmBtn">确定</button>
			</div>
		</tab-modal>
	</div>
</template>
<script>
	//引入弹框提示消息
	import {
		INFO_EMPTY,
		OPERATE_EXCEPTION
	} from 'static/message'
	//引入混合和阻止冒泡函数
	import {
		mapMixin
	} from 'util/util.js'
	//引入车辆base64图标
	import {
		VEHICLE_TRACK
	} from 'static/constant.js'
	//vuex
	import {
		mapState
	} from 'vuex'
	//校验
	import {
		required
	} from 'vuelidate/lib/validators'
	//引入组件
	import StreetMap from './StreetMap' //街景
	import MenuStatus from 'components/pages/didivehiclemonitor/MenuStatus' //车辆状态
	import TabModal from 'components/common/TabModal' //弹框
	import MenuMap from 'components/pages/didivehiclemonitor/MenuMap' //地图菜单
	import MenuMapTool from 'components/pages/didivehiclemonitor/MenuMapTool' //动态菜单-地图
	import MenuVehicle from 'components/pages/didivehiclemonitor/MenuVehicle' //动态菜单-车辆
	import toastr from 'assets/plugins/toastr/toastr.min.js' 
//	import "assets/plugins/bmap/MarkerClusterer.js"
	
	export default {
		name: 'VehicleMonitorMap',
		mixins: [mapMixin],
		components: {
			MenuMap,
			MenuVehicle,
			MenuMapTool,
			TabModal,
			MenuStatus,
			StreetMap
		},
		validations: {
			govAName: { //行政区名称
				required
			},
			content: { //区域名称
				required
			},
			alarmPlan: { //报警计划名称
				required
			},
			startP: { //起点地址
				required
			},
			endPoint: { //终点地址
				required
			}
		},
		data() {
			return {
				loadmap:false, //地图加载
				permission: this.$store.state.permission.permission["monitorVehicle"] ? this.$store.state.permission.permission["monitorVehicle"] : [],
				//地图类
				mapStyle: {
					width: '100%',
					height: '800px'
				},
				mapCenter: {
					lng: 120.39,
					lat: 36.073
				},
				mapZoom: 15,
				enableMapClick:false,
				enableScroll: true,
				//右侧动态菜单--
				showMenuVehicle: false,
				defendStatus: '', //驻防状态
				scopeInfo: {}, //驻防区域信息
				polyDefend: [], //驻防区域多边形
				stopException: '', //异动状态
				stopInfo: {}, //异动信息
				carSearching: '', //追车状态
				disposeAutoComplete:false,
				//街景
				streetViewLayer:null,
				//交通层
				isShowTrafficLayer: false,
				//卫星视图
				isHybridMap: false,
				//测量工具
				enableMeasureTool: false,
				//绘图工具
				enableDrawingTool: false,
				//画围栏
				drawOverlays: [], //画多边形的集合
				drawLabels: [], //画多边形时计算多边形面积的标签
				//画路线 
				setStart:true,
				mSetStart:true,
				//添加标注
				mapLabel: {}, //文本标注实例

				startMarker:null, //起点标注
				endMarker: null, //终点标注

				routeStartPoint: {}, //画路线->起点坐标
				routeEndPoint: {}, //画路线->终点坐标
				routeTransit:null, //画路线->路线实例

				//地图-定位
				markerInfoList: [], //地图上的所有车辆/设备信息集合
				refreshTimer: '',
				refreshSec: 5, //地图上倒计时刷新时间
				refreshFlag: false, //是否开启轮巡
				labelMode: '2', //地图上的标签格式（0，无、1，简单、2，标准）
				carMarkerArr: [], //地图上的车辆标注集合
				carLabelArr: [], //地图上的标签集合
				clickedInfo: {}, //当前点击车辆/设备的信息
				vehiclePosi: {}, //当前点击车辆/设备的坐标
				vehicleAdd: [], //当前点击车辆/设备的地址
				showInfoBox: true, //车辆标注是否显示详细定位信息

				//tabMap操作--往地图添加围栏、路线和标注
				fenceOverlay: [], //添加的围栏
				routeOverlay: [], //添加的路线
				markerOverlay: [], //添加的标注
				currentMenu: '', //当前menumap索引
				markersClicked: false, //默认没有点击标注
				drawMode: '', //利用绘图工具进行哪种操作：驻防、围栏？
				circleArr: [], //驻防对象
				circleLabelArr: [], //驻防标注对象
				//弹框---共用
				modalTitle: '', //每个弹框对应的title
				labelName: '', //绘制图形保存弹框中的保存图形名称
				//弹框--------取消异动或驻防
				stopType: '', //0 驻防，1异动
				hasWithdraw: false, //默认没有取消按钮
				//弹框------行政区划检索
				govAName: '', //待检索的行政区名称
				//弹框--------默认绘制图形保存弹框
				saveFences: false, //是否是保存围栏弹框
				visible: '0', //默认对本企业可见
				content: '',
				memo: '', //保存区域时的备注
				saveType: '', //该弹框保存的绘制类型：fence-保存围栏，note-保存标注，defend-保存驻防  move-保存异动
				areaSize: 0, //区域面积
				points: [], //区域坐标集合
				saveDefend: false, //绘制图形保存弹框为保存驻防信息
				alarmPlan: '', //驻防、异动报警计划id
				alarmPlanList: [], //驻防、异动报警计划列表
				openTabName: '', //要打开的tab名称
				dialog1: '',
				dialog2: '',
				//点击左侧MenuMap的时弹出菜单
				drawType: '', //围栏对应菜单的索引
				pathType: '', //路线对应菜单的索引
				measureType: '', //测量对应菜单的索引
				//测路径
				roadStartPoint: {}, //起点坐标
				roadEndPoint: {}, //终点坐标
				roadMkS:null,
				roadMkE:null,
				transit:null, //路径规划实例
				//测直线
				myDis: {}, //测距类实例
				measureBClicked: false, //是否点击了测直线 
				//测面积
				measureAreaClicked: false, //是否点击了测面积
				pathMenu: false, //点击左侧MenuMap的路线
				infoWindowMenu: false, //点击左侧MenuMap的提示
				//弹框--------规划弹框
				startP: '', //路线规划起点信息，点左侧MenuMap时无默认值，点右上侧MenuVehicle时默认当前车辆位置
				startPts:null,
				endPoint: '',
				endPts:null,
				wayPoints: [], //途径点集合
				wayInputs: [], //动态添加途径点时使用
				oneEnd: true, //路线规划默认只有一个终点
				addEndCount: 0, //路线规划已添加了几个终点
				planMethod: 'shortest', //路线规划policy
				driving:null,   //路线规划实例
				//弹框---------追车弹框
				chaseList: [], //追车列表     
				secondPowerNum:'',	//第二次设置的剩余电量
				firstPowerNum:'',	//第一次设置的剩余电量
				address: '', //标注点的地址信息
				//拉框查车
				srchedVehList:[],
				curVehPage:1,
				srchArea:null,
				srchFuncOpen:true
			}
		},
		computed: {
			...mapState({
				locateOneInfo: state => state.monitor.locateOneInfo,
				locateAllInfo: state => state.monitor.locateAllInfo,
				groupId: state => state.user.groupid,
				markerAdd: state => state.monitor.markerAdd,
				delMarkerId: state => state.monitor.delMarkerId,
				fenceArr: state => state.monitor.fenceArr,
				fenceID: state => state.monitor.fenceID,
				delFenceID: state => state.monitor.delFenceID,
				routeArr: state => state.monitor.routeArr,
				routeID: state => state.monitor.routeID,
				delRouteID: state => state.monitor.delRouteID,
				deletedObj: state => state.monitor.deletedObj,
				loadMap: state => state.monitor.loadMap,
				locateType:state=>state.monitor.locateType
			}),
			isDisable: function() {
				return this.$v.content.required || this.$v.alarmPlan.required
			},
			isClickable: function() {
				return this.$v.startP.required && this.$v.endPoint.required
			},
			isSearchable: function() {
				return this.$v.govAName.required
			}
		},
		watch: {  
			locateOneInfo: function(val) { //为单个车辆定位
				const {map,BMap} = this;
				if(val[0] == null) {
					this.$store.dispatch('tipModalShow', '该车辆无定位信息')
				} else {
					if(val[0].lngBd == '0' || val[0].latBd == '0') {
						this.$store.dispatch('tipModalShow', '该车辆定位信息无效') 
						return
					} 
					if(BMap) {
						this.locateForOne(val)
					} 
						
				}
			},
			locateAllInfo: function(val) { //为多个车辆定位
				if(this.BMap) {
					this.locateForAll(val)
	//				this.vehicleClusterer(val);
				} else {
					this.$store.dispatch('tipModalShow', '请等地图加载完...')
				}
			},
			markerAdd: function(val) { //显示标注
				if(val) {
					this.setAddToMap(val)
				}
			},
			delMarkerId: function(val) { //隐藏标注
				if(val) {
					this.removeMarkerFromMap(val)
				}
			},
			fenceArr: function(val) { //显示围栏
				if(val.length != 0) {
					this.setFenceToMap(val)
				}
			},
			delFenceID(val) { //隐藏围栏
				if(val) {
					this.removeFenceFromMap(val)
				}
			},
			routeArr(val) { //显示路线
				if(val) {
					this.setRouteToMap(val)
				}
			},
			delRouteID(val) { //隐藏路线
				if(val) {
					this.removeRouteFromMap(val)
				}
			},
			'deletedObj.uni' (val) { //删除区域
				if(val) {
					if(this.deletedObj.type == 'marker') {
						this.removeMarkerFromMap(this.deletedObj.id)
					} else if(this.deletedObj.type == 'fence') {
						this.removeFenceFromMap(this.deletedObj.id)
					} else if(this.deletedObj.type == 'route') {
						this.removeRouteFromMap(this.deletedObj.id)
					}
				}
			},
			isShowTrafficLayer: function(newVal) { //交通流量图层--trafficLayer
				const {
					map,
					trafficLayer
				} = this;
				if(newVal) {
					map.addTileLayer(trafficLayer); //将图层添加到地图上
				} else {
					map.removeTileLayer(trafficLayer); // 将图层移除
					this.trafficLayer = null;
				}
			},
			isHybridMap: function(newVal) { //展示卫星视图
				if(newVal) {
					this.currentMenu = 1;
					this.map.setMapType(BMAP_HYBRID_MAP);
				} else {
					this.map.setMapType(BMAP_NORMAL_MAP);
				}
			},
			enableDrawingTool: function(newVal) { //鼠标绘制工具
				if(!newVal) { //enableDrawingTool === false时
					this.drawingManager.close();
					$(".BMapLib_Drawing_panel").empty()
					return;
				} else {
					$(".BMapLib_Drawing_panel").css({
						height: '44px',
						border: 'none',
						borderRadius: '0',
						lineHeight: '44px'
					})
					$(".BMapLib_Drawing_panel").find('a').css({
						backgroundPosition: 'center',
						backgroundColor: '#fff',
						backgroundRepeat: 'no-repeat',
						width: '48px',
						height: '44px',
						border: 'none',
						textAlign: 'center'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(0).css({//拖动地图
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_31 + ')'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(1).css({//画圆
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_32 + ')'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(2).css({//画矩形
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_33 + ')'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(3).css({//画多边形
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_34 + ')'
					})
					$(".BMapLib_Drawing_panel a").click(function() {
						$(".BMapLib_Drawing_panel a").eq($(this).index()).css({
							backgroundColor: '#D2F0EA'
						}).siblings().css({
							backgroundColor: "#fff"
						})
					})
				}
				/*$(".BMapLib_Drawing_panel a").hover(function(){
						$(this).css({backgroundColor:'#F9F9F9'})
					},function(){
						$(this).css({backgroundColor:'#fff'})
					})*/
				if(!this.drawingManager) {
					if(this.drawMode === 'fence') {
						this.drawFences();
					} else if(this.drawMode === 'measureArea') {
						this.measureArea()
					} else {
						return
					}
				}
			},
			enableMeasureTool: function(val) {
				if(val) {
					this.currentMenu = 4;
					this.showMenuVehicle = false;
				} else {
					this.measureType = ''
					this.map.removeEventListener("dblclick", this.handleDbClick);
					this.map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
					this.map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定  
				}
			},
			infoWindowMenu: function(val) {
				if(val) {
					this.currentMenu = 7;
					this.showMenuVehicle = false;
				} else {
					this.labelMode = '2'
				}
			},
			pathMenu: function(val) { //画路线菜单
				if(val) {
					this.currentMenu = 3;
					this.showMenuVehicle = false;
				} else {
					this.map.setDefaultCursor('default') //改变鼠标样式
					this.map.removeEventListener('click', this.drawRouteClick);
				}
			},
			markersClicked: function(val) { //点击标注
				if(!val) {
					this.map.removeOverlay(this.mapLabel)
						//	this.$store.dispatch('clearMap',true)
					this.map.removeEventListener('mousemove', this.handleMouseMove)
					this.map.removeEventListener('dblclick', this.handleRClick)
				}
			},
			showMenuVehicle(val) {
				if(val) {
					this.currentMenu = ''
					this.enableMeasureTool = false;
					this.enableDrawingTool = false;
					this.isShowTrafficLayer = false; //去掉交通层 
					this.isHybridMap = false; //去掉卫星层
					this.pathMenu = false; //去掉路线动态菜单
					this.markersClicked = false //取消点击标注的事件
					this.infoWindowMenu = false //去掉提示动态菜单
				}
			},
			currentMenu(val){
				if(val!=''){
					this.showMenuVehicle = false;
				}
				if(val!=11){//查车以外的其他按钮
					this.srchFuncOpen = false;
					if(this.drawRectangle){
						this.drawRectangle.close()
						this.drawRectangle = null
					} 
				}
				if(val != 0){//路况以外的其他按钮
					this.isShowTrafficLayer = false; //去掉交通层 
				}
				if(val!=1){
					this.isHybridMap = false; //去掉卫星层
				}
				if(val!=2){
					this.enableDrawingTool = false; //去掉画图控件
				}
				if(val!=3){
					this.pathMenu = false; //去掉路线动态菜单
				}
				if(val!=4){
					this.enableMeasureTool = false; //去掉测量动态菜单  
				}
				if(val!=5){
					this.markersClicked = false //取消点击标注的事件
				}
				if(val!=7){
					this.infoWindowMenu = false //去掉提示动态菜单
				}
			}
		},
		methods: {
			ready(obj) { 
				const {
					BMap,
					map
				} = obj;
				const {
					hideLogo,
					loadAsyncScript,
					callback,
					luKuang
				} = this;
				this.map = map;
				this.BMap = BMap;
				//绘多边形工具
				loadAsyncScript("http://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js", () => {});
				//	 loadAsyncScript("http://api.map.baidu.com/library/SearchInfoWindow/1.4/src/SearchInfoWindow_min.js",()=>{});
				//点聚合
				loadAsyncScript("http://api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay_min.js", () => {})
				//测距工具
				loadAsyncScript("http://api.map.baidu.com/library/DistanceTool/1.2/src/DistanceTool_min.js", () => {});
				loadAsyncScript("http://api.map.baidu.com/library/GeoUtils/1.2/src/GeoUtils_min.js", () => {})
				map.disableDoubleClickZoom()
				var opts = {
					anchor:BMAP_ANCHOR_TOP_RIGHT,
					offset: new BMap.Size(560,20)
				}
				map.addControl(new BMap.ScaleControl(opts));
				if(this.locateOneInfo.length!=0){
					this.locateForOne(this.locateOneInfo)
					$('.BMapLabel').css('top','') 
				}
				if(this.locateType===0){ 
					this.getBrowserPos(map, BMap)
				} 
			}, 
			getCurPosi() { //设置车辆轮巡
				this.refreshFlag = true;
				const self = this;
				const {
					map,
					BMap
				} = this;
				clearTimeout(this.refreshTimer)
				let fresh = function() { //倒计时n秒刷新
					if(self.refreshSec >= 1 && self.refreshSec <= 5) {
						self.refreshSec--
					} else {
						self.refreshSec = 5
					}
					
					if(self.refreshSec == 0){
						let random = Math.random().toString(36).substr(2);
						self.$http.get(process.env.API_ROOT + '/monitor/locating/locatings/devices/refresh?random=' + random)
							.then((res) => {
								let nowCarArr = res.body.data;
								for(let i = 0, length = nowCarArr.length; i < length; i++) {
									for(let j = 0, length = self.carMarkerArr.length; j < length; j++) {
										if(nowCarArr[i].deviceId === self.carMarkerArr[j].obj.deviceId) {
											self.adjustOverlay(nowCarArr[i], j, self.carMarkerArr[j].showT)
										}
									}
								}
								self.refreshTimer = setTimeout(fresh, 1000);
							}, (res) => {
								self.$store.dispatch('tipModalShow', res.body.message)
								self.refreshTimer = setTimeout(fresh, 1000);
							})
							.catch((res) => {
								self.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
								self.refreshTimer = setTimeout(fresh, 1000);
							})
					} else {
						self.refreshTimer = setTimeout(fresh, 1000);
					}
					
				};
				this.refreshTimer = setTimeout(fresh, 1000)
			},
			adjustOverlay(info, markerIndex, type) { //随着定位信息改变，动态改变定位属性
				const {
					map,
					BMap
				} = this;
				let aMarker = this.carMarkerArr[markerIndex].overlay;
				//更新位置
				let newPoint = new BMap.Point(info.lngBd, info.latBd)
				aMarker.setPosition(newPoint)
					//更新车辆----1,车辆icon/设备icon
				if(type == 0) { //设备
					let deviceIcon = info.mainFlag == '1' ? VEHICLE_TRACK.vd_icon : VEHICLE_TRACK.map_icon_93
					info.icon = deviceIcon
					var myIcon = new BMap.Icon(deviceIcon, new BMap.Size(33, 33))
					aMarker.setIcon(myIcon)
				} else if(type == 1) { //车辆
					let carIcon = this.getIconUrl(info)
					info.icon = carIcon
					var myIcon = new BMap.Icon(carIcon, new BMap.Size(24, 24))
					aMarker.setIcon(myIcon)
				} else {
					return
				}
				//2,设备标识（主设备还是非主设备）
				let aDeviceIcon = info.mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
				info.deviceIcon = aDeviceIcon
					//3,车辆行驶状态
				let aStatus = this.getStatusByInfo(info)
				info.status = aStatus;
				//4，提示状态
				if(this.labelMode == '0') {
					info.noLabel = 'dis_none'
				} else {
					info.noLabel = 'dis_block'
					info.labelStatus = this.labelMode == '1' ? 'dis_none' : 'dis_block'
				}

				let aLabel = this.carLabelArr[markerIndex].overlay;
				//5,label详细信息是否展开
				let tmpClass = $('.BMapLabel').find('.id_' + info.deviceId).find('.sub-info-box').attr('class')
				if(tmpClass.indexOf('dis_none') == -1) {
					info.toggleBox = 'dis_block'
				} else {
					info.toggleBox = 'dis_none'
				}
				//6,label车辆是否选中的样式
				let dlClass = $('.BMapLabel').find('.id_' + info.deviceId).find('dl').attr('class')
				if(dlClass.indexOf('car_info_border') == -1) {
					info.clicked = ''
				} else {
					info.clicked = 'car_info_border'
				}
				//6,label里权限设置---全设备是否显示
				if(this.permission.indexOf('monitorVehicle_panelExpansionPointAllDevice') == -1) {
					info.device = 'dis_block'
				} else {
					info.device = 'dis_none'
				}
				//7，label里权限设置---档案是否显示
				if(this.permission.indexOf('monitorVehicle_panelExpansionPointFile') == -1) {
					info.file = 'dis_block'
				} else {
					info.file = 'dis_none'
				}
				let labelContent = this.getLabelContent(info)
				aLabel.setContent(labelContent)
				aMarker.setLabel(aLabel) //更新label内容
					//8,注册事件
				$('.BMapLabel .id_' + info.deviceId).parent().css('top', ''); 
				const _self = this;
				let aBox = aLabel.V.children[0]
				aBox.addEventListener('click', function(e) {
					var evt = e || window.event,
						targetN = evt.srcElement ? evt.srcElement : evt.target,
						nodeName = targetN.nodeName.toLowerCase(),
						className = targetN.className;
					if(className.indexOf('marker_arrow') != -1) {
						_self.hideInfoBox(info.deviceId)
					}
					if(className.indexOf('marker_file') != -1) {
						_self.goCarFile(info.plateNumber, info.vehicleId)
					}
					if(className.indexOf('marker_device') != -1) {
						_self.showDevices(info.vehicleId, info.deviceId)
					}
					if(className.indexOf('marker_remove') != -1) {
						_self.removeLocate(info)
					}
				})
				this.updateToolTip()

			},
			locateForOne(val) { //单车定位
				const {
					map,
					BMap
				} = this;  
				if(val[0].lngBd ==='0' ||  val[0].latBd ==='0'){
					this.$store.dispatch('tipModalShow','该车辆定位信息有误，请稍后重试或联系管理员。')
					return
				} 
					let mIndex = this.markerInfoList.findIndex(n => n.deviceId == val[0].deviceId)
					if(mIndex == -1) { //该辆车未定过位
						this.locateOneToMap(val[0])
					} else { //该辆车已定过位-删掉重绘
						let index = this.carMarkerArr.findIndex(n => n.obj.deviceId == val[0].deviceId)
						map.removeOverlay(this.carMarkerArr[index].overlay)
						this.carMarkerArr.splice(index, 1)
						map.removeOverlay(this.carLabelArr[index].overlay)
						this.carLabelArr.splice(index, 1)
						this.markerInfoList.splice(mIndex, 1)
						this.locateOneToMap(val[0])
					} 
				if(this.markerInfoList.length == 1 && !this.refreshFlag) {
					this.getCurPosi()
				}
			},
			locateOneToMap(info) { //为单辆车定位
				const {
					BMap,
					map
				} = this;
				//1,车辆icon
				let icon = this.getIconUrl(info)
				info.icon = icon
					//2,设备标识（主设备还是非主设备）
				let deviceIcon = info.mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
				info.deviceIcon = deviceIcon
					//3,车辆状态
				let status = this.getStatusByInfo(info)
				info.status = status
					//4,提示状态（简单还是标准）
				if(this.labelMode == '0') {
					info.noLabel = 'dis_none'
				} else {
					info.noLabel = 'dis_block'
					info.labelStatus = this.labelMode == '1' ? 'dis_none' : 'dis_block'
				}
				//5,label详细信息是否展开
				info.toggleBox = 'dis_none'
					//6,label是否处于点击后的样式
				info.clicked = ''
				$('.BMapLabel .id_' + info.deviceId).parent().css('top', ''); 
				//7,label里权限设置---全设备是否显示
				if(this.permission.indexOf('monitorVehicle_panelExpansionPointAllDevice') == -1) {
					info.device = 'dis_block'
				} else {
					info.device = 'dis_none'
				}
				//8，label里权限设置---档案是否显示
				if(this.permission.indexOf('monitorVehicle_panelExpansionPointFile') == -1) {
					info.file = 'dis_block'
				} else {
					info.file = 'dis_none'
				}
				//9，添加车辆标注
				this.drawCarMarker(info, 1)
					//10，
				this.markerInfoList.push(info)
					//11,设置地图中心点
				const point = new BMap.Point(info.lngBd, info.latBd)
				map.centerAndZoom(point, 14)
			},
			locateForAll(val) { //多车定位
				let timeStart = new Date().getTime();
				console.log("start...");
				const {
					BMap,
					map
				} = this;
				this.labelMode = '0';
				for(let i = 0, length = val.length; i < length; i++) {
					if(val[i] !== null) {
						if(val[i].lngBd != '' && val[i].latBd != '') {
							let objTmp = this.markerInfoList.find(n => n.deviceId === val[i].deviceId);
							if(objTmp === undefined) {
								//1,车辆icon
								let icon = this.getIconUrl(val[i])
								val[i].icon = icon
									//2,设备标识（主设备还是非主设备）
								let deviceIcon = val[i].mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
								val[i].deviceIcon = deviceIcon
									//3,车辆状态
								let status = this.getStatusByInfo(val[i])
								val[i].status = status
									//4,提示状态（简单还是标准）
//								if(this.labelMode == '0') {
								val[i].noLabel = 'dis_none'
//								} else {
//									val[i].noLabel = 'dis_block'
//									val[i].labelStatus = this.labelMode == '1' ? 'dis_none' : 'dis_block'
//								}
								//5,label详细信息是否展开
								val[i].toggleBox = 'dis_none'
									//6,label是否处于点击后的样式
								val[i].clicked = ''
									//7,label里权限设置---全设备是否显示
								if(this.permission.indexOf('monitorVehicle_panelExpansionPointAllDevice') == -1) {
									val[i].device = 'dis_none'
								} else {
									val[i].device = 'dis_block'
								}
								//8，label里权限设置---档案是否显示
								if(this.permission.indexOf('monitorVehicle_panelExpansionPointFile') == -1) {
									val[i].file = 'dis_none'
								} else {
									val[i].file = 'dis_block'
								}
//								this.drawCarMarker(val[i], 1);
								this.getCarMarker(val[i], 1)
								$('.BMapLabel .id_' + val[i].deviceId).parent().css('top', ''); 
								this.markerInfoList.push(val[i])
							} else {
								let index = this.carMarkerArr.findIndex(n => n.obj.deviceId == val[i].deviceId)
								this.adjustOverlay(val[i], index)
							}
						}
					}
				}
				if(this.markerInfoList.length === val.length && !this.refreshFlag) {
					this.getCurPosi()
				}
				this.carMarkerArr.forEach((item, index) => {
					map.addOverlay(item.overlay);
				})
				//9，设置地图中心点
				let arr = []
				for(let i = 0, length = this.markerInfoList.length; i < length; i++) {
					arr.push(new BMap.Point(this.markerInfoList[i].lngBd, this.markerInfoList[i].latBd))
				}
				let v = map.getViewport(arr)
				map.centerAndZoom(v.center, v.zoom)
				let timeEnd = new Date().getTime();
				console.log(timeEnd - timeStart);
				
			},
			// 点聚合
			vehicleClusterer(val){
				const {
					BMap,
					map
				} = this;
				let markers = [];
				for(let i = 0;i < val.length; i++){
//					let pt = new BMap.Point(val[i].lngBd, val[i].latBd);

					//1,车辆icon
//					let icon = this.getIconUrl(val[i])
//					val[i].icon = icon
						//2,设备标识（主设备还是非主设备）
					let deviceIcon = val[i].mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
					val[i].deviceIcon = deviceIcon
						//3,车辆状态
					let status = this.getStatusByInfo(val[i])
					val[i].status = status
						//4,提示状态（简单还是标准）
					if(this.labelMode == '0') {
						val[i].noLabel = 'dis_none'

					} else {
						val[i].noLabel = 'dis_block'
						val[i].labelStatus = this.labelMode == '1' ? 'dis_none' : 'dis_block'
					}
					//5,label详细信息是否展开
					val[i].toggleBox = 'dis_none'
						//6,label是否处于点击后的样式
					val[i].clicked = ''
						//7,label里权限设置---全设备是否显示
					if(this.permission.indexOf('monitorVehicle_panelExpansionPointAllDevice') == -1) {
						val[i].device = 'dis_none'
					} else {
						val[i].device = 'dis_block'
					}
					//8，label里权限设置---档案是否显示
					if(this.permission.indexOf('monitorVehicle_panelExpansionPointFile') == -1) {
						val[i].file = 'dis_none'
					} else {
						val[i].file = 'dis_block'
					}

					let marker = this.carMarkerBuilder(val[i]);
					markers.push(marker);
				}
				var markerClusterer = new BMapLib.MarkerClusterer(map, {markers:markers});
			},
			// 创建车辆图标对像，聚合使用，暂时废弃
			carMarkerBuilder(info){
				const {
					map,
					BMap
				} = this;
				const that = this;
				let point = new BMap.Point(info.lngBd, info.latBd)
				let myIcon = new BMap.Icon(this.getIconUrl(info), new BMap.Size(33, 33));
				let marker = new BMap.Marker(point, {
					icon: myIcon,
					enableMassClear: false
				});
				marker.addEventListener('click',function(){
					if(marker.getLabel())
						return;
					console.log(marker.getLabel());
					var content = that.getLabelContent(info)
					var label = new BMap.Label(content);
					let randomNo = Math.floor(Math.random() * 5 + 1)
					label.setOffset(new BMap.Size(randomNo, -60));
					label.setStyle({
						border: 'none',
						background: 'none',
						bottom: '5px'
					});
					marker.setLabel(label)
					label.addEventListener('click', function(e) {
						that.vehicleSelected(info)
						$('.BMapLabel .id_' + info.deviceId).unbind("click");
						$('.BMapLabel .id_' + info.deviceId).click(function(e) {
							var targetN = e.target,
								nodeName = targetN.nodeName.toLowerCase(),
								className = targetN.className;
							if(className.indexOf('marker_arrow') != -1) {
								that.hideInfoBox(info.deviceId)
							}
							if(className.indexOf('marker_file') != -1) {
								that.goCarFile(info.plateNumber, info.vehicleId)
							}
							if(className.indexOf('marker_device') != -1) {
								that.showDevices(info.vehicleId, info.deviceId)
							}
							if(className.indexOf('marker_remove') != -1) {
								that.removeLocate(info)
							}
						})
						
					})
				})
				
				marker.addEventListener('click', function() {
					that.vehicleSelected(info)
				})
				return marker;
			},
			// 返回marker对象
			getCarMarker(info, type) {
				const {
					map,
					BMap
				} = this;
				const that = this;
				const point = new BMap.Point(info.lngBd, info.latBd)
				let marker = this.setLocMarker(info.icon,point,24,24) 
				marker.addEventListener('click', function() {
					that.vehicleSelected(info)
				})
//				map.addOverlay(marker)
				const content = this.getLabelContent(info)
				const randomNo = Math.floor(Math.random() * 5 + 1)
				let label =  this.setLocLabel(content,randomNo,-60) 
				marker.setLabel(label)
				label.addEventListener('click', function(e) {
					that.vehicleSelected(info)
				})
				this.$nextTick(()=> {
					$('.BMapLabel .id_' + info.deviceId).click(function(e) {
						var targetN = e.target,
							nodeName = targetN.nodeName.toLowerCase(),
							className = targetN.className;
						if(className.indexOf('marker_arrow') != -1) {
							that.hideInfoBox(info.deviceId)
						}
						if(className.indexOf('marker_file') != -1) {
							that.goCarFile(info.plateNumber, info.vehicleId)
						}
						if(className.indexOf('marker_device') != -1) {
							that.showDevices(info.vehicleId, info.deviceId)
						}
						if(className.indexOf('marker_remove') != -1) {
							that.removeLocate(info)
						}
					})	
					that.updateToolTip()	
				})
				this.carMarkerArr.push({
					overlay: marker,
					obj: info,
					showT: type
				})
				this.carLabelArr.push({
					overlay: label,
					obj: info,
					showT: type
				})
			},
			vehicleSelected(info) { //点击车辆标注
				const {
					map,
					BMap
				} = this;
				this.setTop(info.deviceId)
				this.streetPosi = {
					lng: info.lngBd,
					lat: info.latBd
				}
				let oBox = $('.BMapLabel').find('.id_' + info.deviceId)
				$('.BMapLabel').find('.car_info_box').find('dl').removeClass('car_info_border')
				oBox.find('dl').addClass('car_info_border') 
				oBox.removeClass('dis_none').addClass('dis_block')
				this.vehiclePosi = new BMap.Point(info.lngBd, info.latBd)
				let myGeo = new BMap.Geocoder();
				this.vehicleAdd = []
				const self = this;
				myGeo.getLocation(this.vehiclePosi, function(rs) {
					const addComp = rs.addressComponents;
					self.vehicleAdd.push(addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber)
				})
				this.clickedInfo = info;  
				this.getMenuTool(info.deviceId)
			},
			getMenuTool(dId) {
				this.$http.get(process.env.API_ROOT + '/monitor/locating/menu?deviceId=' + dId)
					.then((res) => {
						let obj = res.body.data;
						this.carSearching = obj.isSearch === 0 ? '追车' : '解除追车'
						this.stopInfo = obj.stopAbnormalMap
						this.stopException = obj.stopAbnormalMap.stopAbnormal === 0 ? '异动' : '解除异动'
						this.scopeInfo = obj.scopeMap
						this.defendStatus = obj.scopeMap.hasScope === 0 ? '驻防' : '显示驻防区域'
						this.showMenuVehicle = true;
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
						this.showMenuVehicle = false;
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
						this.showMenuVehicle = false;
					})
			},
			hideInfoBox(val) { //点车辆标注--隐藏显示carLabel
				const {
					BMap
				} = this;
				$('.BMapLabel .id_' + val).parent().css('top','')
				let oLabel = $('.BMapLabel .id_' + val)
				if(this.showInfoBox) {
					oLabel.find('.marker_arrow').removeClass('downArrow').addClass('upArrow')
					oLabel.find('.sub-info-box').removeClass('dis_none').addClass('dis_block')

				} else {
					oLabel.find('.marker_arrow').removeClass('upArrow').addClass('downArrow')
					oLabel.find('.sub-info-box').removeClass('dis_block').addClass('dis_none')
				}
				this.showInfoBox = !this.showInfoBox
			},
			goCarFile(plateNumber, id) { //点车辆标注--档案
				if(plateNumber) {
					const obj = {
						name: plateNumber,
						id: 'PageFileCarDetail',
						route: '/indexhome/fileCarDetail' + id,
						No: 'file' + id,
						params: {
							id: id
						}
					}
					this.$router.push({
						path: '/indexhome/fileCarDetail' + id,
						query: {
							id: id
						}
					});
					this.$store.dispatch('addTab', obj);
				} else {
					const obj = {
						name: "VE" + id,
						id: 'PageFileCarDetail',
						route: '/indexhome/fileCarDetail' + id,
						No: 'file' + id,
						params: {
							id: id
						}
					}
					this.$router.push({
						path: '/indexhome/fileCarDetail' + id,
						query: {
							id: id
						}
					});
					this.$store.dispatch('addTab', obj);
				}
			},
			showDevices(id, dId) { //获取全设备---vd 标识跟主设备不一样
				this.$http.get(process.env.API_ROOT + '/monitor/locating/locatings/' + id + '/devices/')
					.then((res) => {
						let deviceArr = res.body.data;
						if(deviceArr.length > 1) {
							for(let i = 0, length = deviceArr.length; i < length; i++) {
								if(deviceArr[i].deviceId !== dId) {
									let tmpObj = this.markerInfoList.find(n => n.deviceId == deviceArr[i].deviceId);
									if(tmpObj === undefined) {
										//1,车辆icon
										let icon = deviceArr[i].mainFlag == '1' ? VEHICLE_TRACK.vd_icon : VEHICLE_TRACK.map_icon_93
										deviceArr[i].icon = icon
											//2,设备标识（主设备还是非主设备）
										deviceArr[i].deviceIcon = deviceArr[i].mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
											//3,车辆状态
										let status = this.getStatusByInfo(deviceArr[i])
										deviceArr[i].status = status
											//4,提示状态（简单还是标准）
										if(this.labelMode == '0') {
											deviceArr[i].noLabel = 'dis_none'
										} else {
											deviceArr[i].noLabel = 'dis_block'
											deviceArr[i].labelStatus = this.labelMode == '1' ? 'dis_none' : 'dis_block'
										}
										//5,取消全设备按钮
										deviceArr[i].allDevice = 'dis_none'
										$('.BMapLabel .id_' + deviceArr[i].deviceId).parent().css('top', ''); 
										//6,label详细信息是否展开
										deviceArr[i].toggleBox = 'dis_none'
										this.drawCarMarker(deviceArr[i], 0)
										this.markerInfoList.push(deviceArr[i])
									}
								}
							}
						} else {
							this.$store.dispatch('tipModalShow', '该车辆只有一个设备')
						}
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			removeLocate(info) { //点车辆标注--移除
				let paramArrStr = '';
				let indexD;
				if(info.mainFlag == '1') { //删除所有vehicleId相同的标注
					this.showMenuVehicle = false;
					for(let i = 0, length = this.carMarkerArr.length; i < length; i++) {
						if(this.carMarkerArr[i].obj.vehicleId == info.vehicleId) {
							//paramArr.push(this.carMarkerArr[i].obj.deviceId)
							paramArrStr = paramArrStr + this.carMarkerArr[i].obj.deviceId + ',';
							let delMarker = this.carMarkerArr[i].overlay
							let delLabel = this.carLabelArr[i].overlay
							this.map.removeOverlay(delMarker)
							this.map.removeOverlay(delLabel)
							if(this.clickedInfo.vehicleId == info.vehicleId) {
								if(this.circleArr.length > 0) {
									for(var j = 0, l = this.circleArr.length; j < l; j++) {
										this.map.removeOverlay(this.circleArr[j]);
									}
									this.circleArr = [];
								}

								if(this.circleLabelArr.length > 0) {
									for(var k = 0, l = this.circleLabelArr.length; k < l; k++) {
										this.map.removeOverlay(this.circleLabelArr[k]);
									}
									this.circleLabelArr = [];
								}

								if(this.polyDefend.length > 0) {
									for(let m = 0, length = this.polyDefend.length; m < length; m++) {
										this.map.removeOverlay(this.polyDefend[m])
									}
									this.polyDefend = []
								}

							}
						}
					}
					this.carMarkerArr = this.carMarkerArr.filter(n => n.obj.vehicleId != info.vehicleId)
					this.carLabelArr = this.carLabelArr.filter(n => n.obj.vehicleId != info.vehicleId)
					this.markerInfoList = this.markerInfoList.filter(n => n.vehicleId != info.vehicleId)
				} else { //只删除该设备标注
					this.showMenuVehicle = false //取消车辆动态菜单
					indexD = this.carMarkerArr.findIndex(n => n.obj.deviceId == info.deviceId);
					let delMarker = this.carMarkerArr[indexD].overlay
					let delLabel = this.carLabelArr[indexD].overlay
					this.map.removeOverlay(delMarker)
					this.map.removeOverlay(delLabel)
					this.carMarkerArr.splice(indexD, 1)
					this.carLabelArr.splice(indexD, 1)
					this.markerInfoList.splice(indexD, 1)
				}
				if(this.markerInfoList.length === 0 && this.refreshFlag) { //若所有车辆被移除，清除轮巡
					clearTimeout(this.refreshTimer)
					this.refreshFlag = false
					this.markerInfoList = [];
					this.carLabelArr = [];
					this.carMarkerArr = [];
				}
				let param = {
					deviceId: info.deviceId,
					otherDeviceIds: paramArrStr
				};
				this.$http.delete(process.env.API_ROOT + '/monitor/locating/locatings', {
						params: param
					})
					.then((res) => {
						this.$store.dispatch('tipModalShow', '移除车辆成功')
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			getStatusByInfo(info) {
				let status = ''
				if(info.trackMode == '1') {
					status = '追车'
				} else {
					if(info.almOn != '0' && info.almOn != '') {
						status = '报警'
					} else {
						if(info.onState == '1') {
							status = '离线'
						} else {
							if(info.runState == '0') {
								status = '停车'
							} else {
								status = '行驶'
							}
						}
					}
				}
				return status
			},
			drawCarMarker(info, type) { //添加车辆标注
				const { map,BMap } = this;
				const that = this;
				const point = new BMap.Point(info.lngBd, info.latBd)
				let marker = this.setLocMarker(info.icon,point,24,24) 
				marker.addEventListener('click', function() {
					that.vehicleSelected(info)
				})
				map.addOverlay(marker)
				let randomNo = Math.floor(Math.random() * 5 + 1)
				const content = this.getLabelContent(info)
				let label = this.setLocLabel(content,randomNo,-60) 
				marker.setLabel(label)
				label.addEventListener('click', function(e) {
					that.vehicleSelected(info)
				})
				this.setTop(info.deviceId)
				setTimeout(()=>{
					$('.BMapLabel .id_' + info.deviceId).click(function(e) {
						var targetN = e.target,
							nodeName = targetN.nodeName.toLowerCase(),
							className = targetN.className;
						if(className.indexOf('marker_arrow') != -1) {
							console.log('click the device')
							that.hideInfoBox(info.deviceId)
						}
						if(className.indexOf('marker_file') != -1) {
							that.goCarFile(info.plateNumber, info.vehicleId)
						}
						if(className.indexOf('marker_device') != -1) {
							that.showDevices(info.vehicleId, info.deviceId)
						}
						if(className.indexOf('marker_remove') != -1) {
							that.removeLocate(info)
						}
					})
				},0)
				this.updateToolTip() 
				this.carMarkerArr.push({
					overlay: marker,
					obj: info,
					showT: type
				})
				this.carLabelArr.push({
					overlay: label,
					obj: info,
					showT: type
				})
				this.setTop(info.deviceId)
				this.vehicleSelected(info)
			},
			setTop(dId){
				for(let i = 0, length = this.carMarkerArr.length; i < length; i++) { //被点击的在最上面
					if(this.carMarkerArr[i].obj.deviceId == dId) {
						this.carMarkerArr[i].overlay.setTop(true)
					} else {
						this.carMarkerArr[i].overlay.setTop(false)
					}
				}
			},
			getIconUrl(info) {
				const carIconName = this.picNameByState(info) 
				const icon = this.getPicUrl(carIconName)
				return icon
			},
			getLabelContent(info) { //
				let content = `
					<div class="car_info_box id_${info.deviceId} ${info.noLabel}">
						<dl class="${info.clicked}">
							<dt>
								<span>${info.showFiled1}</span>
								<a class="marker_arrow downArrow"></a>
							</dt>
							<dd class="main-info-box">
								<p class="${info.labelStatus}">
									<span class="marker_show2" data-toggle="tooltip_monitor" data-placement="bottom" title="${info.showFiled2}" tip="${info.showFiled2}">${info.showFiled2}</span>
									<em class="marker_show3" data-toggle="tooltip_monitor" data-placement="bottom" title="${info.showFiled3}" tip="${info.showFiled3}">${info.showFiled3}</em>
								</p>
								<div class="sub-info-box ${info.toggleBox}">
									<p>
										<i>定位于 ${info.gpsTimeStr}</i>
										<b class="${info.deviceIcon}" data-toggle="tooltip_monitor" data-placement="bottom" title="VD${info.deviceId} | ${info.deviceNum}" tip="VD${info.deviceId} | ${info.deviceNum}"></b>
									</p>
									<p>
										<i>时速 ${info.speed}km | ${info.directionName} | ${info.locMode}</i>
									</P>
									<p>
										<i>${info.statusShowStr} | 日行${info.todayMileageKm}km</i>
									</p>
									<strong>
										<a class="marker_file ${info.file}">档案</a>
										<a class="marker_device ${info.allDevice} ${info.device}">全设备</a>
										<a class="marker_remove">移除</a>
									</strong>
								</div>
							</dd>	  
						</dl>
					</div>`
				return content;
			},
			/** 
			 * 异步加载依赖的javascript文件 
			 * src：script的路径 
			 * callback：当外部的javascript文件被load的时候，执行的回调 
			 */
			loadAsyncScript(src, callback) {
				var srcArray = src.split("?")[0].split("/");
				var scr_src = srcArray[srcArray.length - 1];

				// 判断要 添加的脚本是否存在如果存在则不继续添加了  
				var scripts = document.getElementsByTagName("script");
				if(!!scripts && 0 != scripts.length) {
					for(var i = 0; i < scripts.length; i++) {
						if(-1 != scripts[i].src.indexOf(scr_src)) {
							callback();
							return true;
						}
					}
				}
				// 不存在需要的则添加  
				var head = document.getElementsByTagName("head")[0];
				var script = document.createElement("script");
				script.setAttribute("type", "text/javascript");
				script.setAttribute("src", src);
				script.setAttribute("async", true);
				script.setAttribute("defer", true);
				head.appendChild(script);
				if(document.all) {
					script.onreadystatechange = function() {
						var state = this.readyState;
						if(state === 'loaded' || state === 'complete') {
							callback();
						}
					}
				} else {
					//firefox, chrome  
					script.onload = function() {
						callback();
					}
				}
			},
			traffic() { //显示路况拥堵情况，切换开关，再次点击后复原
				if(!this.trafficLayer) {
					this.trafficLayer = new BMap.TrafficLayer(); // 创建交通流量图层实例    
				}
				this.currentMenu = 0
				this.isShowTrafficLayer = !this.isShowTrafficLayer; 
			},
			srchVehicle(){//拉框查车 
				this.currentMenu = 11;
				if(this.srchArea){
					this.closeSrchVeh()
				} 
				this.srchFuncOpen = true;
				const { map,BMap } = this;
					//画矩形区域
				const self = this;
				var drawRectangle = this.setDrawingTool(); 
				if(!this.srchFuncOpen){
					drawRectangle.close()
					return;
				}
				drawRectangle.open() 
				drawRectangle.setDrawingMode(BMAP_DRAWING_RECTANGLE)
				drawRectangle.addEventListener('overlaycomplete', function(e){ 
					drawRectangle.close()
					self.currentMenu = ''
					self.srchArea = e.overlay;
					const path = e.overlay.getPath() 
					//将对角线上两个坐标传给后台拉取车辆信息
					const param = {
						lat1:path[0].lat,
						lng1:path[0].lng,
						lat2:path[2].lat,
						lng2:path[2].lng,
						page_index:1
						
					}
					self.getVehicleWithin(param)
				});
				this.drawRectangle = drawRectangle;
			},
			getVehicleWithin(param){ 
				//process.env.API_ROOT + '/monitor/locating/locatings/draw/graph'
				this.$http.get(process.env.API_ROOT + '/monitor/locating/locatings/draw/graph',{params:param})
				.then(res=>{ 
					//成功拉取完该区域内车辆后-显示车辆信息列表
					const result = res.body.data
					if(result.list.length===0){
						this.closeSrchVeh()
						toastr.info('该区域内暂无车辆数据。') 
						return
					}
					this.srchedVehList = this.srchedVehList.concat(result.list);
					this.curVehPage = result.pageNum;
					this.currentMenu = ''
				},res=>{
					if(res.body.message){
						toastr.info(res.body.message)
						return
					}
					toastr.error('拉取区域内车辆信息失败，请稍后重试。') 
				})
				.catch(res=>{
					console.log(res)
					toastr.error('请求异常') 
				}) 
			},
			getVehInfos(obj){//用户选中了某一个车辆--
				//TODO:1，用去调用左侧树的查询功能。
				let no = obj.vehicleAccount===''?(obj.deviceNum===''?obj.simNum:obj.deviceNum):obj.vehicleAccount 
				this.$store.dispatch('srchTheTree',no)
			},
			srchMoreVeh(){//点击加载更多 
				this.curVehPage ++ 
				const path = this.srchArea.getPath()
				let param = {
					lat1:path[0].lat,
					lng1:path[0].lng,
					lat2:path[2].lat,
					lng2:path[2].lng,
					page_index:this.curVehPage
				}
				this.getVehicleWithin(param)
			},
			setDrawingTool(){
				const { map,BMap } = this;
				var styleOptions = {
						strokeColor: "red", //边线颜色。
						fillColor: "red", //填充颜色。当参数为空时，圆形将没有填充效果。
						strokeWeight: 3, //边线的宽度，以像素为单位。
						strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
						fillOpacity: 0.3, //填充的透明度，取值范围0 - 1。
						strokeStyle: 'solid' //边线的样式，solid或dashed。
					}
				//实例化鼠标绘制工具
				var drawingTool = new BMapLib.DrawingManager(map, {
					isOpen: false, //是否开启绘制模式 
				//	enableDrawingTool:true,
					drawingToolOptions: {
						anchor: BMAP_ANCHOR_TOP_RIGHT, //位置
						offset: new BMap.Size(256, 10), //偏离值
						drawingModes: [ 
							BMAP_DRAWING_RECTANGLE
						]
					}, 
					rectangleOptions: styleOptions //矩形的样式
				});	
				return drawingTool;
			},
			closeSrchVeh(){//关闭查询出来的车辆信息列表
				this.map.removeOverlay(this.srchArea)
				this.srchArea = null;
				this.srchedVehList = []
				this.currentMenu = ''
			},
			drawFences() {//围栏
				this.currentMenu = 2;
				this.saveDefend = false;  
				this.drawType = ''
				const { map,BMap } = this;
				if(this.drawingManager){
					this.drawingManager.close()
					this.drawingManager = null;
				}
				this.enableDrawingTool = !this.enableDrawingTool;
				this.drawMode = 'fence';
				const self = this;
					//实例化鼠标绘制工具
				var drawingManager = this.setDrawingManager(256, 10)
				$('.BMapLib_Drawing_panel').click(function() {
					self.drawType = ''
				})
				var overlaycomplete = function(e) {
					self.drawOverlays.push(e.overlay); //当前多边形对象
					e.label.setStyle({
						border: 'none'
					})
					self.drawLabels.push(e.label); //多边形对应的面积标签
					self.modalTitle = "保存区域";
					self.labelName = "区域保存";
					self.saveFences = true;
					self.saveType = 'fence';
					self.$refs.drawModal.open();
					let path = e.overlay.getPath();
					let pointArr = [];
					for(let i = 0, length = path.length; i < length; i++) {
						pointArr.push({
							lng: path[i].lng,
							lat: path[i].lat
						})
					}
					self.points = pointArr; //坐标集合
					self.areaSize = e.calculate; //面积
				};
				//添加鼠标绘制工具监听事件，用于获取绘制结果
				drawingManager.addEventListener('overlaycomplete', overlaycomplete);
				this.drawingManager = drawingManager;
			},
			setDrawingManager(x,y){
				const {map,BMap} = this;
				var styleOptions = {
							strokeColor: "red", //边线颜色。
							fillColor: "red", //填充颜色。当参数为空时，圆形将没有填充效果。
							strokeWeight: 3, //边线的宽度，以像素为单位。
							strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
							fillOpacity: 0.3, //填充的透明度，取值范围0 - 1。
							strokeStyle: 'solid' //边线的样式，solid或dashed。
						}
				var drawingManager = new BMapLib.DrawingManager(map, {
					isOpen: false, //是否开启绘制模式
					enableDrawingTool: this.enableDrawingTool, //是否显示工具栏
					drawingToolOptions: {
						anchor: BMAP_ANCHOR_TOP_RIGHT, //位置
						offset: new BMap.Size(x,y), //偏离值
						drawingModes: [
							BMAP_DRAWING_CIRCLE,
							BMAP_DRAWING_RECTANGLE,
							BMAP_DRAWING_POLYGON
						]
					},
					circleOptions: styleOptions, //圆的样式
					polygonOptions: styleOptions, //多边形的样式
					rectangleOptions: styleOptions //矩形的样式
				});
				drawingManager.enableCalculate(); //打开距离或面积计算
				return drawingManager;
			},
			govArea() { //画行政区划--弹出行政区划检索框
				this.$refs.modalArea.open()
			},
			closeModalArea() { //关闭行政区划检索框
				this.$refs.modalArea.close()
				this.govAName = ''
				this.$v.govAName.$reset()
			},
			drawGovArea() { //查询按钮---点击开始画行政区划
				let add = this.govAName
				this.getBoundary(add)
				this.$refs.modalArea.close()
			},
			getBoundary(address) {
				const {
					map,
					BMap
				} = this;
				var bdary = new BMap.Boundary();
				const that = this;
				let pointArray = [];
				let plyArray = [];
				bdary.get(address, function(rs) { //获取行政区域
					if(plyArray.length != 0) {
						for(let j = 0, length = plyArray.length; j < length; j++) {
							map.removeOverlay(plyArray[j])
						}
					}
					var count = rs.boundaries.length; //行政区域的点有多少个
					if(count === 0) {
						that.$store.dispatch('tipModalShow', '未能获取当前输入行政区域')
						return;
					}
					for(var i = 0; i < count; i++) {
						var ply = new BMap.Polygon(rs.boundaries[i], {
							strokeColor: "blue",
							strokeWeight: 2,
							strokeOpacity: 0.5
						}); //建立多边形覆盖物
						map.addOverlay(ply); //添加覆盖物
						plyArray = plyArray.concat(ply);
						pointArray = pointArray.concat(ply.getPath());
					}
					map.setViewport(pointArray); //调整视野  
					that.$refs.drawModal.open()
					that.modalTitle = "保存区域";
					that.labelName = "区域保存";
					that.saveFences = true;
					that.saveType = 'fence';
					that.points = pointArray;
					that.areaSize = 0;
					that.govAName = ''
					that.$v.govAName.$reset();
				});
			},
			clearFences() { //围栏->清空所有围栏
				this.$store.dispatch('clearMap', true)
				this.map.clearOverlays();
				this.drawType = 0
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
			},
			getFenceList() { //围栏->列出所有围栏信息
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				this.drawType = 2
				const obj = {
					id: 'FenceList',
					No: 1,
					name: '围栏列表',
					groupId: this.groupId,
					areaType: 1
				}
				const param = {
					page_index:1,
					areaType:1,
					customerId:this.groupId
				} 
				this.$store.dispatch('addMapTab', obj).then(()=>{
					this.$store.dispatch('getAreaList',param)
				})
			},
			setFenceToMap(arr) { //把围栏坐标点转成多边形
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				const {
					BMap
				} = this;
				let point = new BMap.Point(arr[0].lng, arr[0].lat)
				this.map.centerAndZoom(point, 16)
				var polygon = new BMap.Polygon(arr);
				this.map.addOverlay(polygon)
				this.fenceOverlay.push({
					overlay: polygon,
					id: this.fenceID
				})
			},
			removeFenceFromMap(id) { //从地图里删除某个围栏区域
				if(this.drawingManager) {
					this.drawingManager.close()
				}
				const {
					BMap
				} = this;
				for(let i = 0, length = this.fenceOverlay.length; i < length; i++) {
					if(id === this.fenceOverlay[i].id) {
						this.map.removeOverlay(this.fenceOverlay[i].overlay)
					}
				}
			},
			path() { //画路线->显示动态菜单，点击菜单进行操作
				this.pathType = '';
				this.pathMenu = !this.pathMenu; //显示动态菜单 
				this.saveDefend = false;
			},
			delRoute() { //画路线->清空
				this.map.setDefaultCursor('default') //改变鼠标样式
				this.pathType = 0; 
				this.map.removeEventListener('click', this.drawRouteClick);
				this.$store.dispatch('clearMap', true)
				this.map.clearOverlays()
			},
			drawRouteMode() { //画路线->鼠标切为画路线模式
				this.pathType = 1;
				const {
					map
				} = this;
				map.setDefaultCursor('point') //改变鼠标样式
				var overlays = [];
				const self = this;
				this.setStart = true 
				map.addEventListener('click', this.drawRouteClick); //1，获取起点、终点坐标
			},
			drawRouteClick(e) {
				if(!e.overlay){
					const {
						map
					} = this;
					if(this.setStart) {
						if(this.startMarker){
							map.removeOverlay(this.startMarker)
							this.startMarker = null;
						}
						this.routeStartPoint = e.point;
						this.startMarker = new BMap.Marker(e.point)
						map.addOverlay(this.startMarker)
					} else {
						if(this.endMarker){
							map.removeOverlay(this.endMarker)
							this.endMarker = null;
						}
						this.routeEndPoint = e.point;
						this.endMarker = new BMap.Marker(e.point)
						var Label = new BMap.Label('<p>点击保存路线</p>')
						Label.setOffset(new BMap.Size(-40, -33));
						Label.setStyle({
							padding: '10px 10px',
							color: 'red',
							border: 0,
							backgroundColor: 'none'
						})
						this.endMarker.setLabel(Label)
						map.addOverlay(this.endMarker)
						Label.addEventListener('click', this.saveRouteClick)
						this.getRouteLength() //2，获取路径长度
					} 
					this.setStart = !this.setStart 
				} 
			},
			getRouteLength() {
				let pathArr = []
				const {
					map
				} = this; 
				if(this.routeTransit){ 
					this.routeTransit.clearResults();
					this.routeTransit = null;
				}
				const self = this;
				let output = ''  
				this.routeTransit = new BMap.DrivingRoute(map, {
					renderOptions: {
						map: map,
						autoViewport: true,
						enableDragging: true,
						panel: '#distance'
					}
				}); 
				this.routeTransit.setSearchCompleteCallback(function(results){ 
					if(self.routeTransit.getStatus() != BMAP_STATUS_SUCCESS) {
						self.routeTransit.clearResults()
						self.routeTransit = null;
						self.$store.dispatch('tipModalShow', '路径方案处理失败，请调整您的路线') 
						return;
					}
					var plan = results.getPlan(0);
					var planNum = results.getPlan(0).getNumRoutes();
					let arr = []
					for(let j = 0; j < planNum; j++) {
						arr = arr.concat(results.getPlan(0).getRoute(j).getPath())
					}
					self.points = arr;
					self.areaSize = parseInt(plan.getDistance(true)) 
				})
				this.routeTransit.search(this.routeStartPoint, this.routeEndPoint);
			},
			saveRouteClick() {
				this.$refs.drawModal.open();
				this.modalTitle = '保存路线'
				this.labelName = '路线名称'
				this.saveType = 'route'
				this.saveFences = true;
			},
			getPathList() { //画路线->跳转到路线一览面板
				this.pathType = 2;
				this.setStart = true 
				this.map.removeEventListener('click', this.drawRouteClick);
				this.map.setDefaultCursor('default') //改变鼠标样式
				const obj = {
					id: 'RoutesList',
					No: 2,
					name: '路线列表',
					groupId: this.groupId,
					areaType: 2
				}
				const param = {
					page_index:1,
					areaType:2,
					customerId:this.groupId
				}  
				this.$store.dispatch('addMapTab', obj).then(()=>{
					this.$store.dispatch('getAreaList',param)
				})
			},
			setRouteToMap(arr) { //将路线一览里的某条路线显示到地图上
				const {
					map,
					BMap
				} = this;
				const length = arr.length;
				const sPoint = new BMap.Point(arr[0].lng, arr[0].lat)
				map.centerAndZoom(sPoint, 15)
				let sMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_21, sPoint, map, BMap)
				const ePoint = new BMap.Point(arr[length - 1].lng, arr[length - 1].lat)
				let eMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_24, ePoint, map, BMap)
				let pointsArr = [];
				for(let i = 0, length = arr.length; i < length; i++) {
					pointsArr.push(new BMap.Point(arr[i].lng, arr[i].lat))
				}
				let polyLine = new BMap.Polyline(pointsArr, {
					strokeColor: "blue",
					strokeWeight: 3
				})
				map.addOverlay(polyLine);
				this.routeOverlay.push({
					sP: sMarker,
					eP: eMarker,
					line: polyLine,
					id: this.routeID
				})
			},
			removeRouteFromMap(id) { //将地图上的某条路线移出
				for(let i = 0, length = this.routeOverlay.length; i < length; i++) {
					if(this.routeOverlay[i].id === id) {
						this.map.removeOverlay(this.routeOverlay[i].line)
						this.map.removeOverlay(this.routeOverlay[i].sP)
						this.map.removeOverlay(this.routeOverlay[i].eP)
					}
				}
			},
			//和测量有关
			measureClear() { //测量时，清空地图
				this.measureType = 6;
				if(this.drawingManager) { //测过面积
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				if(this.measureBClicked) { //测过直线
					this.myDis.close()
				}
				this.map.clearOverlays()
				this.map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				this.map.removeEventListener("dblclick", this.handleDbClick);
				this.map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件

			},
			measureRoad() { //测路径  1，获取起点、终点坐标  2，获取完终点后计算路径长度
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				const {
					map
				} = this;
				this.measureType = 0;
				this.mSetStart = true; 
				this.enableDrawingTool = false; //关闭测面积事件
				const self = this;
				map.removeEventListener("dblclick", this.handleDbClick); //取消双击获取坐标事件
				map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				map.addEventListener('click', this.measureRoadClick); //1，获取起点、终点坐标	
				if(this.measureBClicked) {
					this.myDis.close()
				}
			},
			measureRoadClick(e) {
				if(!e.overlay){
					const {
						map
					} = this; 
					if(this.mSetStart) {
						this.roadStartPoint = e.point;
						this.roadMkS = new BMap.Marker(e.point)
						map.addOverlay(this.roadMkS)
					} else{
						this.roadEndPoint = e.point;
						this.roadMkE = new BMap.Marker(e.point)
						map.addOverlay(this.roadMkE)
						this.getRoadLength() //2，获取路径长度
					} 
					this.mSetStart = !this.mSetStart;
				} 
			},
			getRoadLength() { //2，from measureRoad->获取路径长度
				const {
					map,BMap
				} = this;
				if(this.transit){
					this.transit.clearResults()
					this.transit = null;
				}
				const self = this;
				let output = '' 
				let opts = {
					map: map,
					autoViewport: true
				}
				var transit =  this.setDrivingRoute(opts)
				let label = null;
				transit.setSearchCompleteCallback(function(results){
					map.removeOverlay(self.roadMkS)
					map.removeOverlay(self.roadMkE)
					self.roadMkS = null;
					self.roadMkE = null;
					if(label){
						map.removeOverlay(label)
						label = null
					}
					if(transit.getStatus() != BMAP_STATUS_SUCCESS) {//当规划失败 
						self.transit.clearResults()
						self.$store.dispatch('tipModalShow', '地图规划行驶方案失败，请合理调整您的路线') 
						return;
					}
					var plan = results.getPlan(0); 
					output += "总路程为：";
					output += plan.getDistance(true) + "\n"; //获取距离
					self.$store.dispatch('tipModalShow', output) 
				})
				transit.search(this.roadStartPoint, this.roadEndPoint);
				this.transit = transit;
			},
			measureBeeline() { // 测直线
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				this.measureBClicked = true;
				const {
					map
				} = this;
				const self = this;
				this.measureType = 1;
				map.removeEventListener("dblclick", this.handleDbClick);
				map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				map.removeEventListener('click', this.measureRoadClick); //取消测路径事件的绑定
				this.enableDrawingTool = false; //取消测面积事件
				map.setDefaultCursor('point') //改变鼠标样式
				var myDis = new BMapLib.DistanceTool(map, {
					lineStroke: 2
				});
				myDis.open()
				myDis.addEventListener("drawend", function(e) {
					$('.BMapLabel').css({
							border: 'none',
							backgroundColor: 'rgba(255,255,255,0)'
						})
						//	self.$store.dispatch('tipModalShow','总长' + e.distance + '米')
				})
				$('.BMapLabel').css({
					border: 'none',
					backgroundColor: 'rgba(255,255,255,0)'
				})
				this.myDis = myDis
			},
			measureArea() { //测面积
				const {
					map
				} = this;
				const self = this;
				if(this.measureBClicked) {
					this.myDis.close()
				}
				map.removeEventListener("dblclick", this.handleDbClick);
				map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				this.measureType = 2;
				if(this.measureType === 2) {
					this.enableDrawingTool = !this.enableDrawingTool;
					this.drawMode = 'measureArea';
					this.enableMeasureTool = true; 
						//实例化鼠标绘制工具
					var drawingManager = this.setDrawingManager(352,10) 
					//添加鼠标绘制工具监听事件，用于获取绘制结果
					drawingManager.addEventListener('overlaycomplete', function(e) {
						let areaSize = Number(e.calculate)
						self.$store.dispatch('tipModalShow', '面积为' + areaSize.toFixed(2) + '平方米')
					});
					this.drawingManager = drawingManager;
				}
			},
			getCoordinate() { // 取坐标--鼠标hover时显示坐标点，双击时选定
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				this.enableDrawingTool = false; //取消画多边形工具
				if(this.measureBClicked) {
					this.myDis.close()
				}
				const {
					map
				} = this;
				map.setDefaultCursor('point') //改变鼠标样式
				this.measureType = 3;
				map.addEventListener("mousemove", this.handleMouseMove);
				map.addEventListener("dblclick", this.handleDbClick);
				map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
			},
			getAddress() { // 查地址---地址检索
				this.map.removeEventListener("dblclick", this.handleDbClick);
				this.map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				this.map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				this.measureType = 4;
				this.enableDrawingTool = false; //关闭测面积的drawingTool
				if(this.measureBClicked) {
					this.myDis.close()
				}
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
			},
			addMarks() { //标注-：1，显示企业所有标注信息；2，鼠标移动显示坐标；3，鼠标右键显示弹框
				this.saveDefend = false;
				this.markersClicked = !this.markersClicked;
				const {
					map
				} = this;
				if(this.markersClicked) {
					this.currentMenu = 5;
					const obj = {
						id: 'MarkersList',
						No: 3,
						name: '标注列表',
						groupId: this.groupId,
						areaType: 3
					}
					const param = {
						page_index:1,
						areaType:3,
						customerId:this.groupId
					}  
					this.$store.dispatch('addMapTab', obj).then(()=>{
						this.$store.dispatch('getAreaList',param)
					}) //1
					map.addEventListener("mousemove", this.handleMouseMove); //2
					map.addEventListener("dblclick", this.handleRClick) //3
				}
			},
			handleMouseMove(e) { //点‘标注’->2,鼠标移动显示坐标
				const {
					map,
					BMap
				} = this;
				map.removeOverlay(this.mapLabel)
				let point = e.point;
				let infoBox = "lng" + point.lng + ' lat' + point.lat;
				if(this.markersClicked) {
					this.addLabel(point, 'dis_block')
				} else {
					this.addLabel(point, 'dis_none')
				}
			},
			handleRClick(e) { //点‘标注’->3,鼠标双击定位到图标
				const {
					map,
					BMap
				} = this;
				let point = {};
				point = e.point;
				map.centerAndZoom(point, 18)
				this.pointToAddress(point) //将坐标转成地址
				map.removeEventListener('mousemove', this.handleMouseMove)
			},
			addLabel(point, display) { //添加文本标注
				const {
					BMap,
					map
				} = this;
				var opts = {
					position: point, // 指定文本标注所在的地理位置
					offset: new BMap.Size(30, -30) //设置文本偏移量
				}
				var marker = new BMap.Marker(point);
				var Label = new BMap.Label(`<p>坐标: ${point.lng},${point.lat}</p>
					<p class="${display}">单击图标保存标注</p>`);
				Label.setOffset(new BMap.Size(15, 15));
				Label.setStyle({
					padding: '10px 10px',
					color: 'red',
					border: 0,
					backgroundColor: 'none'
				})
				marker.setLabel(Label);
				map.addOverlay(marker);
				if(display == 'dis_block') {
					marker.addEventListener('click', this.saveMarker)
				}
				this.mapLabel = marker;
			},
			saveMarker() {
				this.modalTitle = "保存标注";
				this.labelName = "标注名称";
				this.saveType = 'note';
				this.saveFences = true;
				this.$refs.drawModal.open()
			},
			handleDbClick(e) { //取坐标->3,双击鼠标设置地图中心
				this.measureType = '';
				let point = e.point;
				this.map.centerAndZoom(point, 18)
				this.map.removeEventListener('mousemove', this.handleMouseMove);
			},
			pointToAddress(point) { //将坐标转成地址
				const {
					map,
					BMap
				} = this;
				let myGeo = new BMap.Geocoder();
				const self = this;
				myGeo.getLocation(point, function(rs) {
					const addComp = rs.addressComponents;
					self.points = [];
					self.points.push(point);
					self.address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
				})
			},
			setAddToMap(obj) {
				let marker = new BMap.Marker(obj.point)
				this.map.addOverlay(marker)
				this.markerOverlay.push({
					mOverlay: marker,
					mId: obj.id
				})
				let point = new BMap.Point(obj.point.lng, obj.point.lat)
				this.map.centerAndZoom(point, 16)
			},
			removeMarkerFromMap(id) {
				for(let i = 0, length = this.markerOverlay.length; i < length; i++) {
					if(id === this.markerOverlay[i].mId) {
						let point = new BMap.Point(this.markerOverlay[i].mOverlay.point.lng, this.markerOverlay[i].mOverlay.point.lat)
						this.map.centerAndZoom(point, 16)
						let that = this;
						setTimeout(function() {
							that.map.removeOverlay(that.markerOverlay[i].mOverlay)
						}, 500);
					}
				}
			},
			/*
			 路线规划
			 * */
			initPlanModal(){
				this.startP = ''
				this.endPoint = ''
				this.$v.endPoint.$reset();
				this.$v.startP.$reset();
				this.wayPoints = [];
				this.oneEnd = true;
				this.wayInputs = [];
			},
			pathPlan() { // 路线规划  
				this.currentMenu = 6;
				this.$refs.planModal.open() 
				this.openPlanTab()
				this.initPlanModal()
				this.modalTitle = "路线规划";
			},
			openPlanTab() {
				const obj = {
					id: 'RoutePlanDetail',
					No: 4,
					name: '规划详情'
				}
				this.$store.dispatch('addMapTab', obj) //1
			},
			addEnd() { //路线规划里-pathPlan->点击添加途径点-最多有5个途径点
				this.addEndCount++;
				if(this.addEndCount < 5) {
					this.wayInputs.push(this.addEndCount)
					this.oneEnd = false;
				}
			},
			switchPoints() { //路线规划里-pathPlan->当只有一个终点时点击切换终点和起点
				let temP = this.startP;
				this.startP = this.endPoint;
				this.endPoint = temP;
			},
			startPlan() { //路线规划里点开始规划按钮 
				this.currentMenu = ''
				this.$refs.planModal.close()
				let drivingPolicy = [BMAP_DRIVING_POLICY_LEAST_TIME, BMAP_DRIVING_POLICY_LEAST_DISTANCE]
				let i = 0;
				if(this.planMethod === 'fastest') { //速度最快
					i = 0
				} else { //最短距离
					i = 1
				} 
				const { map,BMap} = this;
				if(this.driving){ 
					this.driving.clearResults()
					this.driving = null
				}
				const self = this; 
				let opts = {
					map: map,
					panel: "r-result",
					autoViewport: true
				}
				this.driving =  this.setDrivingRoute(opts,drivingPolicy[i]) 
				this.driving.setSearchCompleteCallback(function(results) { 
					if(self.driving.getStatus() != BMAP_STATUS_SUCCESS) {//当规划失败  
						self.$store.dispatch('tipModalShow', '地图规划行驶方案失败，请合理调整您的路线') 
						self.driving.clearResults()
						return;
					} 
					// 获取第一条方案
					var plan = results.getPlan(0);
					// 获取方案的驾车线路
					var route = plan.getRoute(0);
					// 获取每个关键步骤,并输出到页面 
					var s = [];
					for(var j = 0; j < plan.getNumRoutes(); j++) {
						var route = plan.getRoute(j);
						for(var i = 0; i < route.getNumSteps(); i++) {
							var step = route.getStep(i);
							s.push((i + 1) + ". " + step.getDescription());
						}
					} 
				}) 
				if(this.oneEnd) {  
					this.driving.search(this.startPts, this.endPts);
				} else { 
					this.driving.search(this.startPts, this.endPts, {
						waypoints: this.wayPoints
					});
					this.wayPoints = []
				}
			},
			setDrivingRoute(opts,drivingPolicy){
				const {map,BMap} = this;
				const self = this;
				var driving = null;
				var markersSet = function(pois){ 
					let sMk = pois[0].marker
					let eMk = pois[pois.length-1].marker
					let tipCnt = '<div class="plan_close"></div>'
					let label1 = new BMap.Label(tipCnt)
					let label2 = new BMap.Label(tipCnt)
					label1.setOffset(new BMap.Size(15,-10))
					label2.setOffset(new BMap.Size(15,-10))
					sMk.setLabel(label1)
					eMk.setLabel(label2)
					var toDel = function(){ 
						driving.clearResults()
						driving = null; 
					}
					sMk.addEventListener('click',toDel)
					eMk.addEventListener('click',toDel) 
					label1.setStyle({
						border:0,
						background:'none',
						padding:0
					})
					label2.setStyle({
						border:0,
						background:'none',
						padding:0
					}) 
				}
				if(!drivingPolicy){
					drivingPolicy = 'BMAP_DRIVING_POLICY_LEAST_TIME'
				}
				driving = new BMap.DrivingRoute(map, {
					renderOptions: opts,
					policy: drivingPolicy,
					onMarkersSet: markersSet
				}); 
				return driving;
			},
			setInfoWindow() { //设置车辆信息提示框-
				this.infoWindowMenu = !this.infoWindowMenu;
			},
			noInfo() { //无信息提示框
				this.labelMode = '0'
				$('.BMapLabel').find('.car_info_box').removeClass('dis_block').addClass('dis_none')
			},
			simpleInfo() { //只显示服务号
				this.labelMode = '1'
				$('.BMapLabel').find('.car_info_box').removeClass('dis_none').addClass('dis_block')
				$('.BMapLabel').find('.main-info-box').find('p:first').removeClass('dis_block').addClass('dis_none')
			},
			standardInfo() { //显示服务号和车牌号
				this.labelMode = '2'
				$('.BMapLabel').find('.car_info_box').removeClass('dis_none').addClass('dis_block')
				$('.BMapLabel').find('.main-info-box').find('p:first').removeClass('dis_none').addClass('dis_block')
			},
			clearVehicles(){//当打开页面--页面初始化时，清空车辆
				let param = {
						deviceId: 0
					};
					this.$http.delete(process.env.API_ROOT + '/monitor/locating/locatings', {
							params: param
						})
						.then((res) => { 
						}, (res) => {
							this.$store.dispatch('tipModalShow', res.body.message)
						})
						.catch((res) => {
							this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
						})
			},
			clearMap() { //清空车辆-车辆定位点-carMarkers 
				const {
					map
				} = this;
				this.currentMenu = 8;
				//清空车辆定位点
				this.showMenuVehicle = false //取消车辆动态菜单
				this.refreshFlag = false;
				clearTimeout(this.refreshTimer) 
				let param = {
					deviceId: 0
				};
				this.$http.delete(process.env.API_ROOT + '/monitor/locating/locatings', {
						params: param
					})
					.then((res) => {
						this.$store.dispatch('tipModalShow', '清空车辆成功')
						for(let i = 0, length = this.carLabelArr.length; i < length; i++) {
							map.removeOverlay(this.carLabelArr[i].overlay)
							map.removeOverlay(this.carMarkerArr[i].overlay)
							if(this.carLabelArr[i].obj.vehicleId == this.clickedInfo.vehicleId) {

								if(this.circleArr.length > 0) {
									for(var j = 0, l = this.circleArr.length; j < l; j++) {
										this.map.removeOverlay(this.circleArr[j]);
									}
									this.circleArr = [];
								}

								if(this.circleLabelArr.length > 0) {
									for(var k = 0, l = this.circleLabelArr.length; k < l; k++) {
										this.map.removeOverlay(this.circleLabelArr[k]);
									}
									this.circleLabelArr = [];
								}

								if(this.polyDefend.length > 0) {
									for(let m = 0, length = this.polyDefend.length; m < length; m++) {
										this.map.removeOverlay(this.polyDefend[m])
									}
									this.polyDefend = []
								}
							}
						}
						this.carMarkerArr = [];
						this.carLabelArr = [];
						this.markerInfoList = [];
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					}) 

			},
			saveStyle(val){//保存
				this.currentMenu = val
			},
			/*ModalName:MenuVehicle
			 * 右侧车辆相关动态菜单*/
			/*1，街景*/
			jieJing() { // 街景
				const {map,BMap} = this;
				if(!this.streetViewLayer){
					this.streetViewLayer = new BMap.PanoramaCoverageLayer()	
					map.addTileLayer(this.streetViewLayer);
				}
			},
			closeStreetView() {
				const {map,BMap} = this;
				map.removeTileLayer(this.streetViewLayer)
				this.streetViewLayer = null;
			},
			/*2，驻防*/
			drawDefend() { // 驻防
				const param = { //'21681'
					vehicleId: this.clickedInfo.vehicleId
				}
				this.defendIsStop(param)//--1,判断是否停车
			},
			defendIsStop(param) {//判断是否停车
				this.$http.get(process.env.API_ROOT + '/monitor/areas/garrison/is-stop', {
						params: param
					})
					.then((res) => {
						if(res.body.data === 1) { //2，停车的话
							this.drawDefendArea()//可以画驻防区域
							const param = {
								almType: 3,
								customerId: Number(this.groupId),
								planOwnerType: 1
							}
							this.getAlarmPlanList(param) //获取驻防报警类型下拉表
						} else {
							this.$store.dispatch('tipModalShow', '该车辆未停车，无法设置停车驻防报警')
						}
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						console.log(res)
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			drawDefendArea() { //画驻防区域
				this.saveFences = false;
				this.alarmPlan = ''
				const {
					map,
					BMap
				} = this;
				let circle = {};
				map.removeOverlay(circle)
				for(var i = 0; i < this.circleArr.length; i++) {
					map.removeOverlay(this.circleArr[i]);
				}

				for(var i = 0; i < this.circleLabelArr.length; i++) {
					map.removeOverlay(this.circleLabelArr[i]);
				}
				this.circleLabelArr = [];
				this.circleArr = [];
				
				var point = this.vehiclePosi; // 设置点--车辆定位点
				circle = new BMap.Circle(point, 600);

				map.addOverlay(circle)
				circle.enableEditing();
				this.circleArr.push(circle); 
				let that = this;
				let label;
				var saveCircle = function() {
					that.saveDefend = true;
					that.saveFences = false;
					that.saveType = 'defend';
					that.$refs.drawModal.open()
					that.modalTitle = '原地驻防警戒保存'
					that.openTabName = '打开原地驻防报警计划'
					that.dialog1 = '将为' + that.clickedInfo.showFiled1 +  that.clickedInfo.showFiled2==''?'':'(' + that.clickedInfo.showFiled2 + ')' + '设置驻防报警，车辆超出此范围后，您将获得通知。'
					that.dialog2 = "请选择将当前车辆加入哪个原地驻防的报警计划:"
					let path = circle.getPath()
					that.points = path;
					let r = circle.getRadius()
					that.areaSize = Math.PI * r * r

				}
				var deleteCircle = function(){//删除驻防区域
					map.removeOverlay(circle)
					map.removeOverlay(label)
					that.circleArr = []
					this.circleLabelArr = []; 
				}
				circle.addEventListener('lineupdate', function() { //当圆形属性改变时触发
					let r = circle.getRadius();
					const point = circle.oc[1].point;
					
					map.removeOverlay(label)
					label = new BMap.Label('<p>半径：' + r.toFixed(2) + '米</p><p>请双击驻防区域进行保存或点击<a class="red">此处</a>删除。（注：半径最小500m,最大5km，超出范围无法保存。）</p>', {
						position: point
					})
					label.setOffset(new BMap.Size(15, 15)) 
					map.addOverlay(label)
					that.circleLabelArr.push(label)
					const self = that;
					if(r < 500 || r > 5000) {
						circle.removeEventListener('dblclick', saveCircle)
						label.removeEventListener('click', deleteCircle)
						return
					} else {
						circle.enableEditing();
						circle.addEventListener('dblclick', saveCircle)
						label.addEventListener('click',deleteCircle)
					}
				})
			}, 
			getAlarmPlanList(param) {//获取驻防报警类型下拉表
				this.$http.get(process.env.API_ROOT + '/monitor/areas/garrison/plans', {
						params: param
					})
					.then((res) => {
						if(res.body.data.length == 0) {
							this.$store.dispatch('tipModalShow', '请先添加驻防报警计划')
						} else {
							this.alarmPlanList = res.body.data;
						}

					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			stopDefend() { //取消驻防
				const {
					map,
					BMap
				} = this;
				if(this.polyDefend.length != 0) {
					for(let i = 0, length = this.polyDefend.length; i < length; i++) {
						map.removeOverlay(this.polyDefend[i])
					}
				}
				let polygArr = []
					//1，画出驻防区域
				if(this.scopeInfo.scopePoints != '') {
					const arr = JSON.parse(this.scopeInfo.scopePoints)
					let polyg = new BMap.Polygon(arr, {
						strokeColor: "blue",
						strokeWeight: 2,
						strokeOpacity: 0.5
					})
					polygArr.push(polyg)
					this.mapCenter = arr[0]
					map.addOverlay(polyg)
					const that = this
					polyg.addEventListener('dblclick', function(e) {
						//判断  当前用户所属机构ID ?= 计划所属机构ID
						if(that.groupId == that.scopeInfo.scopeCustomerId) {
							that.$refs.modalD.open() //打开取消驻防弹框
							that.stopType = '驻防'
							that.hasWithdraw = true
							that.modalTitle = "取消驻防"

						} else {
							that.$store.dispatch('tipModalShow', '只有新建该驻防的机构用户可以解除驻防')
						}
					})
					this.polyDefend = polygArr
				}
			},
			/*3，异动*/
			moveAlarm() { //异动
				const param = {
					vehicleId: this.clickedInfo.vehicleId
				}
				this.moveIsStop(param)
			},
			moveIsStop(param) { //停车异动判断停车
				this.$http.get(process.env.API_ROOT + '/monitor/vehicles/alm-plan/parking-exception/is-stop', {
						params: param
					})
					.then((res) => {
						let obj = res.body.data;
						if(res.body.data === 1) {
							this.alarmPlan = ''
							this.saveDefend = true;
							this.saveFences = false;
							this.saveType = 'move';
							this.$refs.drawModal.open()
							this.modalTitle = '停车异动警戒保存'
							this.openTabName = '打开停车异动报警计划'
							this.dialog1 = '将为' + this.clickedInfo.showFiled1 + '（' + this.clickedInfo.showFiled2 + '）设置停车异动报警，当车辆脱离停车状态时，您将获得通知。'
							this.dialog2 = "请选择将当前车辆加入哪个停车异动的报警计划:"
							const param = {
								almType: 19,
								customerId: Number(this.groupId),
								planOwnerType: 1

							}
							this.getAlarmMoveList(param) //如果停车就获取异动下拉表
						}
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			getAlarmMoveList(param) { //如果停车就获取异动下拉表
				this.$http.get(process.env.API_ROOT + '/monitor/vehicles/alm-plan/parking-exception/plans', {
						params: param
					})
					.then((res) => {
						if(res.body.data.length == 0) {
							this.$store.dispatch('tipModalShow', '请先添加停车异动报警计划')
						} else {
							this.alarmPlanList = res.body.data;
						}
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			removeAlaram() { //取消异动
				if(this.groupId == this.stopInfo.stopAbnormalCustomerId) {
					this.$refs.modalD.open() //打开取消异动弹框
					this.stopType = '异动'
					this.hasWithdraw = true
					this.modalTitle = "取消异动"
				} else {
					this.$store.dispatch('tipModalShow', '只有新建该异动的机构用户可以解除异动。')
				}
			},
			closeModalD() { //删除按钮
				this.$refs.modalD.close()
			},
			delWithdrawBtn() { //取消按钮
				this.$refs.modalD.close()
			},
			delConfirmBtn() { //确定按钮--
				if(this.hasWithdraw) {
					if(this.stopType == '驻防') { //取消驻防
						const param = {
							almType: '3',
							customerId: Number(this.groupId),
							vehicleId: this.clickedInfo.vehicleId
						}
						this.delStop(param, '/monitor/areas/garrison')
					} else if(this.stopType == '异动') { //取消异动
						const param = {
							almType: '19',
							customerId: Number(this.groupId),
							vehicleId: this.clickedInfo.vehicleId
						}
						this.delStop(param, '/monitor/vehicles/alm-plan/parking-exception')
					} else {
						return
					}
					this.hasWithdraw = false
					this.$refs.modalD.close()
				} else {
					this.$refs.modalD.close()
				}
			},
			delStop(param, url) { //取消驻防或异动
				this.$http.delete(process.env.API_ROOT + url, {
						params: param
					})
					.then(res => {
						if(param.almType == '3') { //如果成功取消驻防，则在地图上删除驻防区域
							if(this.polyDefend.length != 0) {
								for(let i = 0, length = this.polyDefend.length; i < length; i++) {
									this.map.removeOverlay(this.polyDefend[i])
								}
							}
						}
						this.$store.dispatch('tipModalShow', '取消' + this.stopType + '成功')
							//取消后，右侧菜单改变   
						const that = this;
						this.getMenuTool(that.clickedInfo.deviceId)
						//取消后，手动释放内存
						if(this.stopType=='驻防'){
							this.scopeInfo = null
						}else{
							this.stopInfo = null
						} 
					}, res => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch(res => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			openAlarmTab() { //根据哪种报警选择进入哪种tab
				let obj = {}
				if(this.modalTitle == '原地驻防警戒保存') {
					obj = {
						name: '原地驻防报警计划',
						id: 'PageAlarmPlanList',
						route: '/indexhome/areaAlarmRange',
						No: 'areaAlarmRange'
					}
				} else if(this.modalTitle = '停车异动警戒保存') {
					obj = {
						name: '停车异动报警计划',
						id: 'PageStatusAlarmStop',
						route: '/indexhome/statusAlarmStop',
						No: 'statusAlarmStop'
					}
				} else {
					return
				}
				this.$router.push(obj.route);
				this.$store.dispatch('addTab', obj);
			},
			getAlmPlan() { //弹框刷新按钮
				if(this.saveType == 'defend') {
					const param = {
						almType: 3,
						customerId: Number(this.groupId),
						planOwnerType: 1
					}
					this.getAlarmPlanList(param)
				} else if(this.saveType == 'move') {
					const param = {
						almType: 19,
						customerId: Number(this.groupId),
						planOwnerType: 1

					}
					this.getAlarmMoveList(param) //如果停车就获取异动下拉表
				}
			},
			/*4，规划*/
			routePlan() { //规划
				if(!this.vehicleAdd[0]){
					this.$store.dispatch('tipModalShow','该车辆定位信息有误，无法规划路线。')
					return
				}
				this.initPlanModal()
				this.startP = this.vehicleAdd[0]; //默认值
				this.$refs.planModal.open();  
				this.openPlanTab()
				this.disposeAutoComplete = true;
				this.modalTitle = "为" + this.clickedInfo.showFiled1 + '(' + this.clickedInfo.showFiled2 + ')' + "规划路线";
			},
			/*5，追车*/
			startTracking() { //追车模式
				this.modalTitle = '追车模式设置'
				this.$refs.trackModal.open()
				const vehicleId = this.clickedInfo.vehicleId
				this.getChaseList(vehicleId)
			},
			getChaseList(id) {
				this.$http.get(process.env.API_ROOT + '/monitor/chasing/vehicle/' + id)
					.then((res) => {
						this.chaseList = res.body.data;
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			setCmd(){//设置上传间隔模式
				
			},
			stopTracking() { //取消追车模式

			},   
			withdrawBtn() { //取消按钮-->from track追车弹框
				this.$refs.trackModal.close(); //弹框trackModal关闭
			},
			confirmBtn() { //确定按钮--->from track追车弹框
				//判断电量设置是否为空，若不为空，第一次的值要大于第二次
				console.log(this.firstPowerNum)
				console.log(this.secondPowerNum)
				let firstNum = Number(this.firstPowerNum)
				let secondNum = Number(this.secondPowerNum)
				console.log(firstNum)
				console.log(secondNum)
				if(this.firstPowerNum != ''  && /^\D+$/.test(this.firstPowerNum)){
					this.$store.dispatch('tipModalShow','剩余电量请填写数字')
					return
				}
				if(this.secondPowerNum != ''  && /^\D+$/.test(this.secondPowerNum)){
					this.$store.dispatch('tipModalShow','剩余电量请填写数字')
					return
				}
				if(this.firstPowerNum != '' && this.secondPowerNum != '' && firstNum <= secondNum){
					this.$store.dispatch('tipModalShow','请注意：第一次预警剩余电量必须大于第二次预警剩余电量')
					return
				}
				//TODO：保存设置
				
				this.$refs.trackModal.close(); //弹框trackModal关闭
				
				
			},
			/*保存绘制信息或保存驻防、异动区域*/
			saveBtn() { //保存绘制信息-->drawFences moveAlarm  drawDefend addMarks
				let type = this.saveType;
				let param = {}
				switch (type){
					case 'fence':
					    param = {
							memo: this.memo,
							areaName: this.content,
							areaSize: Number(this.areaSize),
							areaType: '1',
							customerId: Number(this.groupId),
							points: this.points,
							showType: this.visible
						}
						this.saveArea(param)
						break;
					case 'route':
						param = {
							memo: this.memo,
							areaName: this.content,
							areaSize: Number(this.areaSize),
							areaType: '2',
							customerId: Number(this.groupId),
							points: this.points,
							showType: this.visible
						}
						this.saveArea(param)
						break;
					case 'note':
						param = {
							memo: this.memo,
							areaName: this.content,
							areaSize: 0,
							areaType: '3',
							customerId: Number(this.groupId),
							points: this.points,
							showType: this.visible,
							address: this.address
						}
						this.saveArea(param)
						break;
					case 'defend':
						param = {
							alarmType: 3,
							areaSize: Number(this.areaSize),
							areaType: '9',
							customerId: Number(this.groupId),
							planId: this.alarmPlan,
							points: this.points,
							vehicleId: this.clickedInfo.vehicleId
						}
						for(let i = 0, l = this.circleArr.length; i < l; i++) {
							let r = this.circleArr[i].getRadius()
							if(r < 500 || r > 5000) {
								this.$refs.drawModal.close();
								this.$store.dispatch('tipModalShow', '请控制半径在500m-5km')
								return
							}
						}
						this.saveAlaramPlan(param)
						break;
					case 'move':
						param = {
							almType: '19',
							customerId: Number(this.groupId),
							planId: this.alarmPlan,
							vehicleId: this.clickedInfo.vehicleId
						}
						this.saveMovePlan(param)
					default:
						return
						break;
				} 
				this.$refs.drawModal.close();
			},
			saveArea(param) { //保存围栏、路线和标注
				this.loadmap = true;
				this.$http.post(process.env.API_ROOT + '/monitor/areas', param)
					.then((res) => {
						if(res.body.code == '200') {
							this.loadmap = false;
							//1,提示保存成功
							this.$store.dispatch('tipModalShow', '保存成功')
							this.setStart = true
								//2，将input输入重置
							this.content = ''
							this.memo = ''
							this.$v.content.$reset()
								//3，拉取区域列表
							const getObj = {
								page_index: 1,
								areaType: param.areaType,
								customerId: this.groupId
							}
							this.$store.dispatch('getAreaList', getObj)
								//4，清空地图
							this.clearDrawing()
						} else {
							this.loadmap = false;
							this.$store.dispatch('tipModalShow', res.body.message)
						}
					}, (res) => {
						this.loadmap = false;
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.loadmap = false;
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			clearDrawing() { 
				if(this.saveType == 'fence') { //围栏
					this.map.removeOverlay(this.drawOverlays[0])
					this.map.removeOverlay(this.drawLabels[0])
					this.drawLabels = []
					this.drawOverlays = []
				} else if(this.saveType == 'route') { //路线 
					this.routeTransit.clearResults() 
					this.map.removeOverlay(this.endMarker)
					this.map.removeOverlay(this.startMarker)
					this.endMarker = null;
					this.startMarker = null;
				} else if(this.saveType == 'note') { //标注
					this.map.removeOverlay(this.mapLabel);
					this.mapLabel = null
				} else {
					return
				}
			},
			saveAlaramPlan(param) { //保存驻防报警
				this.loadmap = true;
				this.$http.post(process.env.API_ROOT + '/monitor/areas/garrison/', param)
					.then((res) => {
						this.loadmap = false;
						this.alarmPlan = '';
						this.$v.alarmPlan.$reset()
						this.$store.dispatch('tipModalShow', '保存成功')
							//保存成功后，右侧菜单改变   
						const that = this;
						this.getMenuTool(that.clickedInfo.deviceId)
							//删除驻防区域
						if(this.circleArr.length > 0) {
							for(let m = 0, length = this.circleArr.length; m < length; m++) {
								this.map.removeOverlay(this.circleArr[m])
							}
							this.circleArr = []
						}
						if(this.circleLabelArr.length > 0) {
							for(var k = 0, l = this.circleLabelArr.length; k < l; k++) {
								this.map.removeOverlay(this.circleLabelArr[k]);
							}
							this.circleLabelArr = [];
						}
					}, (res) => {
						this.loadmap = false;
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.loadmap = false;
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			saveMovePlan(param) { //保存停车异动报警
				this.$http.post(process.env.API_ROOT + '/monitor/vehicles/alm-plan/parking-exception', param)
					.then((res) => {
						this.alarmPlan = '';
						this.$v.alarmPlan.$reset()
						this.$store.dispatch('tipModalShow', '保存成功')
							//保存后，右侧菜单改变   
						const that = this;
						this.getMenuTool(that.clickedInfo.deviceId)
					}, (res) => {
						this.$store.dispatch('tipModalShow', res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
					})
			},
			closeModal() { //点击弹框右上方X按钮 -->drawFences
				//1，清空地图
				this.clearDrawing()
					//2,初始化模态框
				this.$refs.drawModal.close();  //弹框drawModal关闭
				this.saveDefend = false;       //默认不是原地驻防保存
				this.saveFences = false;       //默认不是保存围栏区域
				this.$refs.planModal.close();  //弹框planModal关闭
				this.$refs.trackModal.close(); //弹框trackModal关闭
				this.content = ''
				this.memo = ''
				this.$v.content.$reset()
				this.alarmPlan = ''
				this.$v.alarmPlan.$reset() 
			}, 
			adsSearch() { //点地址检索
				this.drawType = 1;
			},
			searchStart(id, resId) { //输入起点提示
				var ac = this.searchCommon(id, resId)
				let newVal = ''
				const that = this;
				ac.addEventListener("onconfirm", function(e) {  
					var _value = e.item.value
					newVal = _value.province + _value.city + _value.district + _value.street + _value.business;;
					G(resId).innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + newVal;
					that.switchAdsToPts(newVal,'start')
					that.startP = newVal
				})
			},
			searchEnd(id, resId) { //输入终点提示
				var ac = this.searchCommon(id, resId)
				let newVal = ''
				const that = this;
				ac.addEventListener("onconfirm", function(e) {
					var _value = e.item.value
					newVal = _value.province + _value.city + _value.district + _value.street + _value.business;;
					G(resId).innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + newVal;
					that.switchAdsToPts(newVal,'end')
					that.endPoint = newVal
				})
			},
			searchInput(event, id, resId) { //规划时输入途径点提示
				var ac = this.searchCommon(id, resId)
				let newVal = ''
				const that = this;
				ac.addEventListener("onconfirm", function(e) { 
					var _value = e.item.value
					newVal = _value.province + _value.city + _value.district + _value.street + _value.business;
					G(resId).innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + newVal;
					that.switchAdsToPts(newVal,'way')
					event.target.value = newVal  
				})
				
			},
			switchAdsToPts(ads,type){
				const {map,BMap} = this;
				const that = this;
				let myGeo =  new BMap.Geocoder(); 
				let pts = null;
				myGeo.getPoint(ads,function(point){
					if(point){
						switch(type){
							case 'start':
								that.startPts = point;
								break;
							case 'end':
								that.endPts = point;
								break;
							case 'way':
								that.wayPoints.push(point);
								break;
							default:
								break;
						} 
					}else{
						that.$store.dispatch('tipModalShow','系统解析失败，请重新调整地址。')
						return;
					}
				}) 
			},
			searchAds() { //地址检索时的输入提示
				var ac = this.searchCommon('suggestId', 'searchResultPanel')
				var myValue;
				let self = this;
				ac.addEventListener("onconfirm", function(e) { //鼠标点击下拉列表后的事件
					var _value = e.item.value;
					myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
					G("searchResultPanel").innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
					self.setPlace(myValue);
				});
			},
			searchCommon(id, resId) {
				const {
					map,
					BMap
				} = this;
				const that = this;
				var ac = new BMap.Autocomplete( //建立一个自动完成的对象
					{
						"input": id,
						"location": map,
						onSearchComplete:function(){
							if(that.disposeAutoComplete){
								console.log('隐藏')
								ac.hide()
								that.disposeAutoComplete = false
							} 
						}
					});
				ac.addEventListener("onhighlight", function(e) { //鼠标放在下拉列表上的事件
					var str = "";
					var _value = e.fromitem.value;
					var value = "";
					if(e.fromitem.index > -1) {
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

					value = "";
					if(e.toitem.index > -1) {
						_value = e.toitem.value;
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					G(resId).innerHTML = str;
				});
				return ac
			},
			setPlace(myValue) { //地址检索时调用的方法
				const {
					map
				} = this;
				map.clearOverlays(); //清除地图上所有覆盖物
				var myFun = function() {
					var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
					map.centerAndZoom(pp, 18);
					map.addOverlay(new BMap.Marker(pp));
				}
				var local = new BMap.LocalSearch(map, { //智能搜索
					onSearchComplete: myFun
				});
				local.search(myValue);
			},
			updateToolTip(){
				this.$nextTick(function() { 
					$('[data-toggle="tooltip_monitor"]').tooltip() 
					$('[data-toggle="tooltip_monitor"]').hover(function(e){ 
					 	$(e.currentTarget).attr('data-original-title',$(e.currentTarget).attr('tip')).tooltip('fixTitle').tooltip('show') 
					 },function(e){
					 	$(e.currentTarget).attr('data-original-title','')
					 	
					}) 
				})
			}
		}, 
		beforeMount(){
			//调清空车辆接口
			this.clearVehicles()
			this.$nextTick(()=>{
    		toastr.option={
					"closeButton":true,
					"progressBar":true
				}
	    	}) 
		},
		mounted() {  
			const that = this;
			window.onresize = function temp() {
		    	that.mapStyle.height = $('#content-main').height() + 'px'; 
		    }; 
			this.mapStyle.height = $('#content-main').height() + 'px';
			clearTimeout(this.refreshTimer) 
		}, 
		beforeDestroy() {
			this.refreshFlag = false;
			clearTimeout(this.refreshTimer)
			this.$store.dispatch('resetState')
			// const obj = {
			// 		num:0,
			// 		uni:new Date().getTime()
			// } 
			// this.$store.dispatch('openTreeTab',obj) 
			$('[data-toggle="tooltip_monitor"]').tooltip('hide')  
			this.carMarkerArr = [];
			this.carLabelArr = [];
			this.markerInfoList = [];
		}
	}

	function G(id) {
		return document.getElementById(id);
	}
</script>
<style scoped lang="scss">
	dl.veh_list{
		position:absolute;
		right:292px;
		top:56px; 
		height:332px;
		overflow:hidden;
		background:#eee;
		padding:5px;
		box-shadow:1px 1px 5px rgba(0,0,0,0.4);
		dt{
			height:32px;
			line-height:32px;
			text-align: center;
			background-color:#eee;
			span{
				float:left;
			}
			img{
				margin-top:6px;
				float:right;
				cursor:pointer;
			}
		}
		dd{
			background-color:#fff;
			list-style: none;  
			&.title{
				font-weight: 700;
				height:24px; 
				line-height: 24px;
			}
			&.srched_vehs{
				height:266px;
				overflow:auto;
				border:1px solid #ddd;
				p{
					border-bottom:1px dotted #ddd;
					height:24px; 
					line-height: 24px;
					margin-bottom:0;
					cursor:default;
					&:hover{
						background-color:#D2F0EA
					}
					&:active{
						background-color:#46AC89;
					}
					&.load_veh{
						text-align: center;
						font-weight: 700;
		   				cursor: pointer;
					}
				}
			}  
		}
		
	}
	
</style>



// WEBPACK FOOTER //
// VehicleMonitorMap.vue?82c67e70